(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[9],{

/***/ "0A8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ GenIcon; });

// UNUSED EXPORTS: IconsManifest, IconBase, DefaultContext, IconContext

// CONCATENATED MODULE: ./node_modules/@hacknug/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./node_modules/@hacknug/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react_default.a.createContext && react_default.a.createContext(DefaultContext);
// CONCATENATED MODULE: ./node_modules/@hacknug/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react_default.a.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react_default.a.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react_default.a.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react_default.a.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react_default.a.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
// CONCATENATED MODULE: ./node_modules/@hacknug/react-icons/lib/esm/index.js




/***/ }),

/***/ "2CXu":
/***/ (function(module, exports) {

var characterMap = {
	"À": "A",
	"Á": "A",
	"Â": "A",
	"Ã": "A",
	"Ä": "A",
	"Å": "A",
	"Ấ": "A",
	"Ắ": "A",
	"Ẳ": "A",
	"Ẵ": "A",
	"Ặ": "A",
	"Æ": "AE",
	"Ầ": "A",
	"Ằ": "A",
	"Ȃ": "A",
	"Ç": "C",
	"Ḉ": "C",
	"È": "E",
	"É": "E",
	"Ê": "E",
	"Ë": "E",
	"Ế": "E",
	"Ḗ": "E",
	"Ề": "E",
	"Ḕ": "E",
	"Ḝ": "E",
	"Ȇ": "E",
	"Ì": "I",
	"Í": "I",
	"Î": "I",
	"Ï": "I",
	"Ḯ": "I",
	"Ȋ": "I",
	"Ð": "D",
	"Ñ": "N",
	"Ò": "O",
	"Ó": "O",
	"Ô": "O",
	"Õ": "O",
	"Ö": "O",
	"Ø": "O",
	"Ố": "O",
	"Ṍ": "O",
	"Ṓ": "O",
	"Ȏ": "O",
	"Ù": "U",
	"Ú": "U",
	"Û": "U",
	"Ü": "U",
	"Ý": "Y",
	"à": "a",
	"á": "a",
	"â": "a",
	"ã": "a",
	"ä": "a",
	"å": "a",
	"ấ": "a",
	"ắ": "a",
	"ẳ": "a",
	"ẵ": "a",
	"ặ": "a",
	"æ": "ae",
	"ầ": "a",
	"ằ": "a",
	"ȃ": "a",
	"ç": "c",
	"ḉ": "c",
	"è": "e",
	"é": "e",
	"ê": "e",
	"ë": "e",
	"ế": "e",
	"ḗ": "e",
	"ề": "e",
	"ḕ": "e",
	"ḝ": "e",
	"ȇ": "e",
	"ì": "i",
	"í": "i",
	"î": "i",
	"ï": "i",
	"ḯ": "i",
	"ȋ": "i",
	"ð": "d",
	"ñ": "n",
	"ò": "o",
	"ó": "o",
	"ô": "o",
	"õ": "o",
	"ö": "o",
	"ø": "o",
	"ố": "o",
	"ṍ": "o",
	"ṓ": "o",
	"ȏ": "o",
	"ù": "u",
	"ú": "u",
	"û": "u",
	"ü": "u",
	"ý": "y",
	"ÿ": "y",
	"Ā": "A",
	"ā": "a",
	"Ă": "A",
	"ă": "a",
	"Ą": "A",
	"ą": "a",
	"Ć": "C",
	"ć": "c",
	"Ĉ": "C",
	"ĉ": "c",
	"Ċ": "C",
	"ċ": "c",
	"Č": "C",
	"č": "c",
	"C̆": "C",
	"c̆": "c",
	"Ď": "D",
	"ď": "d",
	"Đ": "D",
	"đ": "d",
	"Ē": "E",
	"ē": "e",
	"Ĕ": "E",
	"ĕ": "e",
	"Ė": "E",
	"ė": "e",
	"Ę": "E",
	"ę": "e",
	"Ě": "E",
	"ě": "e",
	"Ĝ": "G",
	"Ǵ": "G",
	"ĝ": "g",
	"ǵ": "g",
	"Ğ": "G",
	"ğ": "g",
	"Ġ": "G",
	"ġ": "g",
	"Ģ": "G",
	"ģ": "g",
	"Ĥ": "H",
	"ĥ": "h",
	"Ħ": "H",
	"ħ": "h",
	"Ḫ": "H",
	"ḫ": "h",
	"Ĩ": "I",
	"ĩ": "i",
	"Ī": "I",
	"ī": "i",
	"Ĭ": "I",
	"ĭ": "i",
	"Į": "I",
	"į": "i",
	"İ": "I",
	"ı": "i",
	"Ĳ": "IJ",
	"ĳ": "ij",
	"Ĵ": "J",
	"ĵ": "j",
	"Ķ": "K",
	"ķ": "k",
	"Ḱ": "K",
	"ḱ": "k",
	"K̆": "K",
	"k̆": "k",
	"Ĺ": "L",
	"ĺ": "l",
	"Ļ": "L",
	"ļ": "l",
	"Ľ": "L",
	"ľ": "l",
	"Ŀ": "L",
	"ŀ": "l",
	"Ł": "l",
	"ł": "l",
	"Ḿ": "M",
	"ḿ": "m",
	"M̆": "M",
	"m̆": "m",
	"Ń": "N",
	"ń": "n",
	"Ņ": "N",
	"ņ": "n",
	"Ň": "N",
	"ň": "n",
	"ŉ": "n",
	"N̆": "N",
	"n̆": "n",
	"Ō": "O",
	"ō": "o",
	"Ŏ": "O",
	"ŏ": "o",
	"Ő": "O",
	"ő": "o",
	"Œ": "OE",
	"œ": "oe",
	"P̆": "P",
	"p̆": "p",
	"Ŕ": "R",
	"ŕ": "r",
	"Ŗ": "R",
	"ŗ": "r",
	"Ř": "R",
	"ř": "r",
	"R̆": "R",
	"r̆": "r",
	"Ȓ": "R",
	"ȓ": "r",
	"Ś": "S",
	"ś": "s",
	"Ŝ": "S",
	"ŝ": "s",
	"Ş": "S",
	"Ș": "S",
	"ș": "s",
	"ş": "s",
	"Š": "S",
	"š": "s",
	"Ţ": "T",
	"ţ": "t",
	"ț": "t",
	"Ț": "T",
	"Ť": "T",
	"ť": "t",
	"Ŧ": "T",
	"ŧ": "t",
	"T̆": "T",
	"t̆": "t",
	"Ũ": "U",
	"ũ": "u",
	"Ū": "U",
	"ū": "u",
	"Ŭ": "U",
	"ŭ": "u",
	"Ů": "U",
	"ů": "u",
	"Ű": "U",
	"ű": "u",
	"Ų": "U",
	"ų": "u",
	"Ȗ": "U",
	"ȗ": "u",
	"V̆": "V",
	"v̆": "v",
	"Ŵ": "W",
	"ŵ": "w",
	"Ẃ": "W",
	"ẃ": "w",
	"X̆": "X",
	"x̆": "x",
	"Ŷ": "Y",
	"ŷ": "y",
	"Ÿ": "Y",
	"Y̆": "Y",
	"y̆": "y",
	"Ź": "Z",
	"ź": "z",
	"Ż": "Z",
	"ż": "z",
	"Ž": "Z",
	"ž": "z",
	"ſ": "s",
	"ƒ": "f",
	"Ơ": "O",
	"ơ": "o",
	"Ư": "U",
	"ư": "u",
	"Ǎ": "A",
	"ǎ": "a",
	"Ǐ": "I",
	"ǐ": "i",
	"Ǒ": "O",
	"ǒ": "o",
	"Ǔ": "U",
	"ǔ": "u",
	"Ǖ": "U",
	"ǖ": "u",
	"Ǘ": "U",
	"ǘ": "u",
	"Ǚ": "U",
	"ǚ": "u",
	"Ǜ": "U",
	"ǜ": "u",
	"Ứ": "U",
	"ứ": "u",
	"Ṹ": "U",
	"ṹ": "u",
	"Ǻ": "A",
	"ǻ": "a",
	"Ǽ": "AE",
	"ǽ": "ae",
	"Ǿ": "O",
	"ǿ": "o",
	"Þ": "TH",
	"þ": "th",
	"Ṕ": "P",
	"ṕ": "p",
	"Ṥ": "S",
	"ṥ": "s",
	"X́": "X",
	"x́": "x",
	"Ѓ": "Г",
	"ѓ": "г",
	"Ќ": "К",
	"ќ": "к",
	"A̋": "A",
	"a̋": "a",
	"E̋": "E",
	"e̋": "e",
	"I̋": "I",
	"i̋": "i",
	"Ǹ": "N",
	"ǹ": "n",
	"Ồ": "O",
	"ồ": "o",
	"Ṑ": "O",
	"ṑ": "o",
	"Ừ": "U",
	"ừ": "u",
	"Ẁ": "W",
	"ẁ": "w",
	"Ỳ": "Y",
	"ỳ": "y",
	"Ȁ": "A",
	"ȁ": "a",
	"Ȅ": "E",
	"ȅ": "e",
	"Ȉ": "I",
	"ȉ": "i",
	"Ȍ": "O",
	"ȍ": "o",
	"Ȑ": "R",
	"ȑ": "r",
	"Ȕ": "U",
	"ȕ": "u",
	"B̌": "B",
	"b̌": "b",
	"Č̣": "C",
	"č̣": "c",
	"Ê̌": "E",
	"ê̌": "e",
	"F̌": "F",
	"f̌": "f",
	"Ǧ": "G",
	"ǧ": "g",
	"Ȟ": "H",
	"ȟ": "h",
	"J̌": "J",
	"ǰ": "j",
	"Ǩ": "K",
	"ǩ": "k",
	"M̌": "M",
	"m̌": "m",
	"P̌": "P",
	"p̌": "p",
	"Q̌": "Q",
	"q̌": "q",
	"Ř̩": "R",
	"ř̩": "r",
	"Ṧ": "S",
	"ṧ": "s",
	"V̌": "V",
	"v̌": "v",
	"W̌": "W",
	"w̌": "w",
	"X̌": "X",
	"x̌": "x",
	"Y̌": "Y",
	"y̌": "y",
	"A̧": "A",
	"a̧": "a",
	"B̧": "B",
	"b̧": "b",
	"Ḑ": "D",
	"ḑ": "d",
	"Ȩ": "E",
	"ȩ": "e",
	"Ɛ̧": "E",
	"ɛ̧": "e",
	"Ḩ": "H",
	"ḩ": "h",
	"I̧": "I",
	"i̧": "i",
	"Ɨ̧": "I",
	"ɨ̧": "i",
	"M̧": "M",
	"m̧": "m",
	"O̧": "O",
	"o̧": "o",
	"Q̧": "Q",
	"q̧": "q",
	"U̧": "U",
	"u̧": "u",
	"X̧": "X",
	"x̧": "x",
	"Z̧": "Z",
	"z̧": "z",
};

var chars = Object.keys(characterMap).join('|');
var allAccents = new RegExp(chars, 'g');
var firstAccent = new RegExp(chars, '');

var removeAccents = function(string) {	
	return string.replace(allAccents, function(match) {
		return characterMap[match];
	});
};

var hasAccents = function(string) {
	return !!string.match(firstAccent);
};

module.exports = removeAccents;
module.exports.has = hasAccents;
module.exports.remove = removeAccents;


/***/ }),

/***/ "2W6z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "2rMq":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ "2zs7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__("2rMq");

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),

/***/ "5ULk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// CONCATENATED MODULE: ./node_modules/@loomhq/loom-embed/dist/esm/index.js
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/common.ts
var LOOM_BASE_REGEX_STR = "(?:https?://)?((?:stage.loom.com|loom.com|www.loom.com|loomlocal.com:4444)/share/[a-f0-9]+)";
var LOOM_URL_REGEX = new RegExp(`^${LOOM_BASE_REGEX_STR}$`);
var LOOM_URL_MATCH_REGEX = new RegExp(`${LOOM_BASE_REGEX_STR}`, "g");
var LOOM_HOSTNAME_CAPTURE = /(www\.loom\.com|loom\.com|stage\.loom\.com|loomlocal\.com:4444)/i;
var LINK_REPLACED_CLASS = "lo-link-replaced";

// src/validate.ts
var isLoomUrl = (url) => LOOM_URL_REGEX.test(url);
var isValidEmbedUrl = (url) => isLoomUrl(url);
var isValidLinkNode = (node) => !node.className.includes(LINK_REPLACED_CLASS) && isValidEmbedUrl(node.href);
var validate_default = {
  isLoomUrl
};

// src/oembed.ts
var SRC_URL_REGEX = /src=["']+(https?:\/\/[a-zA-z\d:\.\/?&]+)/;
var getResponsiveEmbedCode = (embedURL, heightAspectRatio) => {
  const padding = `${heightAspectRatio * 100}%`;
  const wrapperStyles = `position: relative; padding-bottom: ${padding}; height: 0;`;
  const iframeStyles = "position: absolute; top: 0; left: 0; width: 100%; height: 100%;";
  const staticAttributes = 'frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen';
  return `
<div class="lo-emb-vid" style="${wrapperStyles}">
  <iframe src="${embedURL}" style="${iframeStyles}" ${staticAttributes}></iframe>
</div>`.split("\n").map((s) => s.trim()).join("");
};
var chooseAspectRatio = (data) => {
  const { width, height } = data;
  if (width == null || height == null) {
    return 1080 / 1920;
  }
  return height / width;
};
var enhanceEmbedCode = (videoData, options) => {
  const { width, height } = options;
  if (!width && !height) {
    const [, embedUrl] = videoData.html.match(SRC_URL_REGEX);
    const aspectRatio = chooseAspectRatio(videoData);
    return __spreadProps(__spreadValues({}, videoData), {
      html: getResponsiveEmbedCode(embedUrl, aspectRatio)
    });
  }
  return videoData;
};
var buildLoomOembedUrl = (url, options) => {
  const { width, height, gifThumbnail, hideOwner } = options;
  const maxWidth = width ? `&maxwidth=${width}` : "";
  const maxHeight = height ? `&maxheight=${height}` : "";
  const gifParam = gifThumbnail ? `&gif=${gifThumbnail}` : "";
  const ownerParam = hideOwner ? `&hide_owner=${hideOwner}` : "";
  const [loomDomain] = url.match(LOOM_HOSTNAME_CAPTURE);
  let loomBaseDomain = loomDomain;
  if (loomDomain === "loom.com") {
    loomBaseDomain = `www.${loomDomain}`;
  }
  return `https://${loomBaseDomain}/v1/oembed?url=${url}${maxWidth}${maxHeight}${gifParam}${ownerParam}`;
};
var oembed = (linkUrl, options = {}) => {
  const isSupportedUrl = isValidEmbedUrl(linkUrl);
  if (isSupportedUrl) {
    return fetch(buildLoomOembedUrl(linkUrl, options)).then((resp) => resp.json()).then((videoData) => enhanceEmbedCode(videoData, options)).catch((e) => {
      throw new Error("Unable to fetch oembed data:" + e);
    });
  }
  throw new Error("URL is not from a supported video provider");
};
var gifEmbed = async (linkUrl) => {
  const oEmbed = await oembed(linkUrl, { gifThumbnail: true });
  return `<a href="${linkUrl}">
    <img style="max-width:300px;" src="${oEmbed.thumbnail_url}">
  </a>`;
};

// src/linkReplace.ts
var createNodeFromString = (htmlString) => {
  const containerNode = document.createElement("div");
  containerNode.innerHTML = htmlString;
  return containerNode.firstChild;
};
var injectVideo = (linkNode, embedString) => {
  const embedNode = createNodeFromString(embedString);
  if (embedNode && linkNode.parentNode) {
    linkNode.parentNode.insertBefore(embedNode, linkNode);
  }
};
var linkReplace = (selector = "a", options = {}, target = document) => {
  const linkNodes = [
    ...Array.from(target.querySelectorAll(selector))
  ];
  linkNodes.filter((item) => isValidLinkNode(item)).forEach(async (node) => {
    const { html } = await oembed(node.href, options);
    injectVideo(node, html);
    node.className = `${node.className} ${LINK_REPLACED_CLASS}`;
    return true;
  });
};

// src/textReplace.ts
var normalizeUrls = (url) => {
  const [, loomBaseUrl] = url.match(LOOM_URL_REGEX);
  return {
    originalUrl: url,
    requestUrl: `https://${loomBaseUrl}`
  };
};
var textReplace = async (textString, options = {}) => {
  const textInput = textString || "";
  const loomMatches = textInput.match(LOOM_URL_MATCH_REGEX);
  if (!loomMatches) {
    return textInput;
  }
  const embedPromises = loomMatches.map(normalizeUrls).map(async (urls) => {
    const { html } = await oembed(urls.requestUrl, options);
    return __spreadProps(__spreadValues({}, urls), {
      embedCode: html
    });
  });
  const embedData = await Promise.all(embedPromises);
  return embedData.reduce((acc, curr) => {
    const { originalUrl, embedCode } = curr;
    const urlReplaceRegex = new RegExp(originalUrl, "g");
    return acc.replace(urlReplaceRegex, embedCode);
  }, textInput);
};

//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./src/components/VideoEmbed/LoomEmbed.jsx


var __jsx = react_default.a.createElement;


var LOOM_SHARE_URL = "https://www.loom.com/share";
var SELECTOR_ROOT = "loom-video";

var LoomEmbed_LoomEmbed = function LoomEmbed(_ref) {
  var id = _ref.id,
      children = _ref.children;
  var url = "".concat(LOOM_SHARE_URL, "/").concat(id);

  var _useState = Object(react["useState"])(),
      metadata = _useState[0],
      setMetadata = _useState[1];

  var selector = "".concat(SELECTOR_ROOT, "-").concat(id);

  var loadVideo = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _metadata;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              linkReplace(".".concat(selector));

              if (true) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return oembed(url);

            case 4:
              _metadata = _context.sent;
              console.log("".concat(selector, " metadata:"), _metadata);

            case 6:
              setMetadata(metadata);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadVideo() {
      return _ref2.apply(this, arguments);
    };
  }();

  Object(react["useEffect"])(function () {
    loadVideo();
  }, [id]);

  var content = __jsx("a", {
    className: selector,
    href: url
  });

  return children ? __jsx("div", {
    className: "relative"
  }, content, children) : content;
};

/* harmony default export */ var VideoEmbed_LoomEmbed = (LoomEmbed_LoomEmbed);
// CONCATENATED MODULE: ./node_modules/react-lite-youtube-embed/dist/index.es.jsx
/**
* react-lite-youtube-embed v2.3.1
*  https://github.com/ibrahimcesar/react-lite-youtube-embed.git
*
*  Copyright (c) Ibrahim Cesar < email@ibrahimcesar.com > and project contributors.
*
*  This source code is licensed under the MIT license found in the
*  LICENSE file in the root directory of this source tree.
*
*  Author site: https://ibrahimcesar.cloud
*/
    

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function LiteYouTubeEmbed(props) {
    var _a = react["useState"](false), preconnected = _a[0], setPreconnected = _a[1];
    var _b = react["useState"](false), iframe = _b[0], setIframe = _b[1];
    var videoId = encodeURIComponent(props.id);
    var videoPlaylisCovertId = typeof props.playlistCoverId === 'string' ? encodeURIComponent(props.playlistCoverId) : null;
    var videoTitle = props.title;
    var posterImp = props.poster || "hqdefault";
    var paramsImp = "&" + props.params || false;
    var mutedImp = props.muted ? "&mute=1" : "";
    var announceWatch = props.announce || "Watch";
    var format = props.webp ? 'webp' : 'jpg';
    var vi = props.webp ? 'vi_webp' : 'vi';
    var posterUrl = props.thumbnail || (!props.playlist
        ? "https://i.ytimg.com/" + vi + "/" + videoId + "/" + posterImp + "." + format
        : "https://i.ytimg.com/" + vi + "/" + videoPlaylisCovertId + "/" + posterImp + "." + format);
    var ytUrl = props.noCookie
        ? "https://www.youtube-nocookie.com"
        : "https://www.youtube.com";
    ytUrl = props.cookie
        ? "https://www.youtube.com"
        : "https://www.youtube-nocookie.com";
    var iframeSrc = !props.playlist
        ? ytUrl + "/embed/" + videoId + "?autoplay=1&state=1" + mutedImp + paramsImp
        : ytUrl + "/embed/videoseries?autoplay=1" + mutedImp + "&list=" + videoId + paramsImp;
    var activatedClassImp = props.activatedClass || "lyt-activated";
    var adNetworkImp = props.adNetwork || false;
    var aspectHeight = props.aspectHeight || 9;
    var aspectWidth = props.aspectWidth || 16;
    var iframeClassImp = props.iframeClass || "";
    var playerClassImp = props.playerClass || "lty-playbtn";
    var wrapperClassImp = props.wrapperClass || "yt-lite";
    var onIframeAdded = props.onIframeAdded || function () { };
    var rel = props.rel ? 'prefetch' : 'preload';
    var warmConnections = function () {
        if (preconnected)
            return;
        setPreconnected(true);
    };
    var addIframe = function () {
        if (iframe)
            return;
        setIframe(true);
    };
    react["useEffect"](function () {
        if (iframe) {
            onIframeAdded();
        }
    }, [iframe]);
    return (react["createElement"](react["Fragment"], null,
        react["createElement"]("link", { rel: rel, href: posterUrl, as: "image" }),
        react["createElement"](react["Fragment"], null, preconnected && (react["createElement"](react["Fragment"], null,
            react["createElement"]("link", { rel: "preconnect", href: ytUrl }),
            react["createElement"]("link", { rel: "preconnect", href: "https://www.google.com" }),
            adNetworkImp && (react["createElement"](react["Fragment"], null,
                react["createElement"]("link", { rel: "preconnect", href: "https://static.doubleclick.net" }),
                react["createElement"]("link", { rel: "preconnect", href: "https://googleads.g.doubleclick.net" })))))),
        react["createElement"]("article", { onPointerOver: warmConnections, onClick: addIframe, className: wrapperClassImp + " " + (iframe ? activatedClassImp : ""), "data-title": videoTitle, style: __assign({ backgroundImage: "url(" + posterUrl + ")" }, {
                '--aspect-ratio': (aspectHeight / aspectWidth) * 100 + "%",
            }) },
            react["createElement"]("button", { className: playerClassImp, "aria-label": announceWatch + " " + videoTitle }),
            iframe && (react["createElement"]("iframe", { className: iframeClassImp, title: videoTitle, width: "560", height: "315", frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, src: iframeSrc })))));
}


//# sourceMappingURL=index.es.jsx.map

// CONCATENATED MODULE: ./src/components/VideoPreview/styles.js
var styles = [".yt-lite{background-color:#000;position:relative;display:block;contain:content;background-position:center center;background-size:cover;cursor:pointer;width:100%;}", ".yt-lite::before{content:\"\";display:block;position:absolute;top:0;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==);background-position:top;background-repeat:repeat-x;height:60px;padding-bottom:50px;width:100%;-webkit-transition:all 0.2s cubic-bezier(0,0,0.2,1);transition:all 0.2s cubic-bezier(0,0,0.2,1);}", ".yt-lite::after{content:\"\";display:block;padding-bottom:calc(100% / (16 / 9));}", ".yt-lite > iframe{width:100%;height:100%;position:absolute;top:0;left:0;}", ".yt-lite > .lty-playbtn{width:70px;height:46px;background-color:#212121;z-index:1;opacity:0.8;border-radius:14%;-webkit-transition:all 0.2s cubic-bezier(0,0,0.2,1);transition:all 0.2s cubic-bezier(0,0,0.2,1);}", ".yt-lite:hover > .lty-playbtn{background-color:#f00;opacity:1;}", ".yt-lite > .lty-playbtn:before{content:\"\";border-style:solid;border-width:11px 0 11px 19px;border-color:transparent transparent transparent #fff;}", ".yt-lite.jsx-3015736715>.lty-playbtn.jsx-3015736715,.yt-lite > .lty-playbtn:before{position:absolute;top:50%;left:50%;-webkit-transform:translate3d(-50%,-50%,0);-ms-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);}", ".yt-lite.lyt-activated{cursor:unset;}", ".yt-lite.lyt-activated.jsx-3015736715::before,.yt-lite.lyt-activated > .lty-playbtn{opacity:0;pointer-events:none;}"];
styles.__hash = "3015736715";
// EXTERNAL MODULE: ./src/components/CommandPalette/constants.js
var constants = __webpack_require__("VSLR");

// CONCATENATED MODULE: ./src/components/VideoEmbed/index.jsx




var _SERVICE_COMPONENT;


var VideoEmbed_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var VideoEmbed_Loom = function Loom(_ref) {
  var service_uid = _ref.service_uid,
      children = _ref.children;
  return VideoEmbed_jsx(VideoEmbed_LoomEmbed, {
    key: service_uid,
    id: service_uid
  }, children);
};

var VideoEmbed_YouTube = function YouTube(_ref2) {
  var service_uid = _ref2.service_uid,
      config = _ref2.config,
      children = _ref2.children;
  var props = {
    id: service_uid
  };
  constants["h" /* YOU_TUBE_EMBED_KEYS */].reduce(function (memo, key) {
    var value = config[key];

    if (typeof value !== "undefined") {
      props[key] = value;
    }

    return memo;
  }, {});

  var content = VideoEmbed_jsx(react["Fragment"], null, VideoEmbed_jsx(LiteYouTubeEmbed, props), VideoEmbed_jsx(style_default.a, {
    id: styles.__hash
  }, styles));

  return children ? VideoEmbed_jsx("div", {
    className: "relative"
  }, content, children) : content;
};

var SERVICE_COMPONENT = (_SERVICE_COMPONENT = {}, Object(defineProperty["a" /* default */])(_SERVICE_COMPONENT, constants["b" /* COMMAND_SERVICE */].LOOM, VideoEmbed_Loom), Object(defineProperty["a" /* default */])(_SERVICE_COMPONENT, constants["b" /* COMMAND_SERVICE */].YOU_TUBE, VideoEmbed_YouTube), _SERVICE_COMPONENT);
/**
 * @param {Object} props
 * @param {String} props.id - id
 * @param {String} props.title - video title
 * @param {String} props.service - originating service (Loom / YouTube)
 * @param {String} props.service_uid - service id
 * @param {String} props.type - video etc.
 * @param {Object} props.config - player specific config
 * @param {Object} props.children
 * @returns
 */

var VideoEmbed_VideoEmbed = function VideoEmbed(_ref3) {
  var service = _ref3.service,
      config = _ref3.config,
      children = _ref3.children,
      remainder = Object(objectWithoutProperties["a" /* default */])(_ref3, ["service", "config", "children"]);

  var ServiceComp = SERVICE_COMPONENT[service];

  var serviceConfig = _objectSpread(_objectSpread({}, constants["e" /* DEFAULT_SERVICE_CONFIG */][service]), config);

  return VideoEmbed_jsx(ServiceComp, Object(esm_extends["a" /* default */])({
    service: service,
    config: serviceConfig
  }, remainder, {
    key: remainder.id
  }), children);
};

/* harmony default export */ var components_VideoEmbed = __webpack_exports__["a"] = (VideoEmbed_VideoEmbed);

/***/ }),

/***/ "7L7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommandClient */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useCommand; });
/* unused harmony export CommandContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommandContextProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useCommandContext; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KQm4");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("HaE+");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("1OyB");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("vuIU");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("jMmE");
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("BkRI");
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("RBan");
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_last__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("bt/X");
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_groupBy__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _command__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("sc12");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("vDqi");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _paths__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("5mj7");






var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/prop-types */








var CommandClient = /*#__PURE__*/function () {
  function CommandClient() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        apiKey = _ref.apiKey,
        debug = _ref.debug;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, CommandClient);

    this.apiKey = apiKey || null;
    this.debug = debug || false;
    this.rootUrl = _paths__WEBPACK_IMPORTED_MODULE_13__[/* API_PATHS */ "a"].COMMANDS;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(CommandClient, [{
    key: "fetch",
    value: function () {
      var _fetch = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee(id) {
        var requestUrl, props, response;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                requestUrl = id ? "".concat(this.rootUrl, "/").concat(id) : this.rootUrl;
                props = {
                  method: "get",
                  url: requestUrl,
                  headers: this.apiKey ? {
                    Authorization: "Bearer ".concat(this.apiKey)
                  } : {}
                };
                _context.next = 5;
                return axios__WEBPACK_IMPORTED_MODULE_12___default()(props);

              case 5:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }]);

  return CommandClient;
}();
var useCommand = function useCommand(_ref2) {
  var id = _ref2.id;
  var client = Object(react__WEBPACK_IMPORTED_MODULE_6__["useMemo"])(function () {
    return new CommandClient();
  }, []);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])(null),
      command = _useState[0],
      setCommand = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])(null),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])(!id ? new Error("Command id is required") : null),
      error = _useState3[0],
      setError = _useState3[1];
  /**
   * Fetch provided command
   */


  var fetchCommand = /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee2() {
      var result;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return client.fetch(id);

            case 3:
              result = _context2.sent;

              if (result instanceof Error) {
                setError(result);
              } else {
                setCommand(result);
              }

              setLoading(false);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchCommand() {
      return _ref3.apply(this, arguments);
    };
  }();

  Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
    id && fetchCommand();
  }, [id]);
  return {
    loading: loading,
    error: error,
    command: command
  };
};

var _createUseContext = Object(___WEBPACK_IMPORTED_MODULE_7__[/* createUseContext */ "b"])(
/* eslint-disable-next-line react/display-name */
function (Provider) {
  return function (_ref4) {
    var children = _ref4.children,
        id = _ref4.id,
        apiKey = _ref4.apiKey,
        commands = _ref4.commands,
        customActions = _ref4.actions,
        initialValues = _ref4.initialValues,
        debug = _ref4.debug,
        preventKeyboardTrigger = _ref4.preventKeyboardTrigger;
    var ctxDebug = debug || false;

    var _useState4 = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])({
      history: initialValues && initialValues.history ? initialValues.history : [],
      index: 0,
      debug: ctxDebug,
      query: "",
      open: false
    }),
        values = _useState4[0],
        setValues = _useState4[1];

    var activeId = lodash_last__WEBPACK_IMPORTED_MODULE_9___default()(values.history);

    var _useState5 = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])([]),
        fetchedCommands = _useState5[0],
        setFetchedCommands = _useState5[1];

    var _useState6 = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])(false),
        loading = _useState6[0],
        setLoading = _useState6[1];

    var _useState7 = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])(null),
        error = _useState7[0],
        setError = _useState7[1];

    var client = Object(react__WEBPACK_IMPORTED_MODULE_6__["useMemo"])(function () {
      return new CommandClient({
        apiKey: apiKey,
        debug: ctxDebug
      });
    }, [apiKey]);
    var allCommands = Object(react__WEBPACK_IMPORTED_MODULE_6__["useMemo"])(function () {
      var result = [];
      [commands, fetchedCommands].forEach(function (collection) {
        if (Array.isArray(collection)) {
          result = result.concat(collection);
        }
      });
      return result;
    }, [commands, fetchedCommands]);
    var commandsMap = Object(react__WEBPACK_IMPORTED_MODULE_6__["useMemo"])(function () {
      return (
        /* eslint-disable-next-line react/display-name, react/prop-types */
        allCommands.reduce(function (memo, command) {
          if (command) {
            memo[command.id] = command;
          }

          return memo;
        }, {})
      );
    }, [allCommands]);
    /**
     * Fetch configured commands
     */

    var fetchCommands = /*#__PURE__*/function () {
      var _ref5 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee3() {
        var result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                setLoading(true);
                _context3.next = 3;
                return client.fetch(id);

              case 3:
                result = _context3.sent;

                if (result instanceof Error) {
                  setError(result);
                } else if (Array.isArray(result)) {
                  setFetchedCommands(result);
                }

                setLoading(false);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function fetchCommands() {
        return _ref5.apply(this, arguments);
      };
    }();

    Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
      fetchCommands();
    }, []);
    /**
     * If there is an active id
     * - then filter to all with a parent
     * - else return all without
     */

    var _useMemo = Object(react__WEBPACK_IMPORTED_MODULE_6__["useMemo"])(function () {
      return Object(_command__WEBPACK_IMPORTED_MODULE_11__[/* reduceCommands */ "b"])({
        commands: allCommands,
        query: values.query,
        activeId: activeId
      });
    }, [allCommands, values.query, activeId]),
        filtered = _useMemo.filtered,
        suggestions = _useMemo.suggestions;
    /**
     * Get upper bound index of visible items
     * - If index is above upper bound
     * - Then reset index
     */


    var maxIndex = filtered.length;

    if (suggestions.length) {
      maxIndex += suggestions.length;
    }

    maxIndex -= 1;
    Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
      if (values.index > maxIndex) {
        setFieldValue("index", 0);
      }
    }, [values.index, maxIndex]);
    var setFieldValue = Object(react__WEBPACK_IMPORTED_MODULE_6__["useCallback"])(function (path, value) {
      var updatedValues = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_8___default()(values);
      updatedValues[path] = value;
      setValues(updatedValues);
    }, [values]);
    /**
     * Setup keyboard shortcut listener
     */

    Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
      var onKeydown = function onKeydown(e) {
        var isCmdKTrigger = e.key === "k" && (e.metaKey || e.ctrlKey);

        if (isCmdKTrigger) {
          e.preventDefault();
          setFieldValue("open", true);
        }
      };

      if (!preventKeyboardTrigger) {
        window.addEventListener("keydown", onKeydown);
      }

      return function () {
        !preventKeyboardTrigger && window.removeEventListener("keydown", onKeydown);
      };
    }, []);
    var setOpen = Object(react__WEBPACK_IMPORTED_MODULE_6__["useCallback"])(function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      setFieldValue("open", value);
    }, [values]);
    var reset = Object(react__WEBPACK_IMPORTED_MODULE_6__["useCallback"])(function () {
      values.debug && console.log("Reset command bar state");
      setTimeout(function () {
        return setValues({
          history: [],
          index: 0,
          debug: false,
          query: "",
          open: false
        });
      }, 0);
    }, [values]);
    var addHistory = Object(react__WEBPACK_IMPORTED_MODULE_6__["useCallback"])(function (value) {
      if (value) {
        var updatedValues = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_8___default()(values);
        updatedValues.history.push(value);
        updatedValues.debug && console.log("Add history: ".concat(value));
        updatedValues.query = "";
        updatedValues.index = 0;
        setValues(updatedValues);
      } else {
        console.log("No history to add");
      }
    }, [values]);
    var popHistory = Object(react__WEBPACK_IMPORTED_MODULE_6__["useCallback"])(function () {
      if (Array.isArray(values.history) && values.history.length) {
        var updatedValues = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_8___default()(values);
        var updatedHistory = updatedValues.history;
        var poppedHistory = updatedHistory.pop();
        updatedValues.debug && console.log("Pop history: ".concat(poppedHistory));
        updatedValues.history = updatedHistory;
        updatedValues.index = 0;
        setValues(updatedValues);
      } else {
        values.debug && console.log("No history to pop");
      }
    }, [values]);
    var decrementIndex = Object(react__WEBPACK_IMPORTED_MODULE_6__["useCallback"])(function () {
      var updatedValues = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_8___default()(values);

      if (updatedValues.index > 0) {
        updatedValues.index -= 1;
        setValues(updatedValues);
        updatedValues.debug && console.log("Decrement to index: ".concat(updatedValues.index));
      }
    }, [values]);
    var incrementIndex = Object(react__WEBPACK_IMPORTED_MODULE_6__["useCallback"])(function () {
      var updatedValues = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_8___default()(values);
      var newIndex = updatedValues.index + 1;

      if (newIndex <= maxIndex) {
        updatedValues.index = newIndex;
        setValues(updatedValues);
        updatedValues.debug && console.log("Increment to index: ".concat(updatedValues.index));
      }
    }, [values]);
    var performIndex = Object(react__WEBPACK_IMPORTED_MODULE_6__["useCallback"])(function () {
      var allVisibleCommands = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(filtered), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(suggestions));
      var command = allVisibleCommands[values.index];

      if (command) {
        if (command.perform) {
          if (command.perform.type) {
            var commandAction = customActions[command.perform.type];

            if (commandAction) {
              commandAction(command.perform.props);
            } else {
              "Unsupported perform type: ".concat(item.perform.type, ". Make sure ").concat(item.perform.type, " has a corresponding key within actions.");
            }
          } else {
            command.perform();
          }

          reset && setTimeout(reset, 0);
        } else {
          addHistory(command.id);
        }
      } else {
        console.error("No command for index: ".concat(values.index));
      }
    }, [values, filtered, suggestions]);
    return __jsx(Provider, {
      value: {
        values: values,
        setValues: setValues,
        setFieldValue: setFieldValue,
        loading: loading,
        error: error,
        commands: allCommands,
        commandsMap: commandsMap,
        filtered: filtered,
        suggestions: suggestions,
        sections: lodash_groupBy__WEBPACK_IMPORTED_MODULE_10___default()(filtered, "section"),
        activeId: activeId,
        activeCommand: commandsMap[activeId],
        actions: _objectSpread({
          addHistory: addHistory,
          setOpen: setOpen,
          popHistory: popHistory,
          reset: reset,
          incrementIndex: incrementIndex,
          decrementIndex: decrementIndex,
          performIndex: performIndex
        }, customActions)
      }
    }, children);
  };
}),
    CommandContext = _createUseContext.Context,
    CommandContextProvider = _createUseContext.ContextProvider,
    useCommandContext = _createUseContext.useContext;



/***/ }),

/***/ "9rZX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__("qFS3");

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ "D9Aj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WHAT_INTEGRATION */
/* unused harmony export HELP_DISABLED_ACCOUNT */
/* unused harmony export HELP_SUSPENDED_SUBSCRIPTION */
/* unused harmony export INTEGRATION_REQUEST_FIELD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return crispComposerWithMessage; });
/* unused harmony export crispField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return crispHide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return crispShow; });
// https://help.crisp.chat/en/article/how-to-use-dollarcrisp-javascript-sdk-10ud15y/
var WHAT_INTEGRATION = "What integration would you like?";
var HELP_DISABLED_ACCOUNT = "Has your account been incorrectly disabled? Let us know why.";
var HELP_SUSPENDED_SUBSCRIPTION = "Has your subscription been suspended incorrectly? Let us know why.";
var INTEGRATION_REQUEST_FIELD = {
  id: "integration-request",
  text: "What integration would you like?",
  explain: "Enter an integration name..."
};
var DEFAULT_HELP_MESSAGE = "What can we help with?";
var crispComposerWithMessage = function crispComposerWithMessage() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_HELP_MESSAGE;

  if ( true && window.$crisp) {
    window.$crisp.push(["do", "message:show", ["text", message]]);
  }
};
var crispField = function crispField(field) {
  if ( true && window.$crisp) {
    window.$crisp.push(["do", "message:show", ["field", field]]);
  }
};
var crispHide = function crispHide() {
  if ( true && window.$crisp) {
    window.$crisp.push(["do", "chat:hide"]);
  }
};
var crispShow = function crispShow() {
  if ( true && window.$crisp) {
    window.$crisp.push(["do", "chat:show"]);
  }
};

/***/ }),

/***/ "MR80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__("g4pe");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// CONCATENATED MODULE: ./src/components/Static/Head/index.jsx
var __jsx = react_default.a.createElement;




var Head_StaticHead = function StaticHead(_ref) {
  var meta = _ref.meta;
  var router = Object(next_router["useRouter"])();
  return __jsx(head_default.a, null, __jsx("title", null, meta.title), __jsx("meta", {
    name: "robots",
    content: "follow, index"
  }), __jsx("meta", {
    content: meta.description,
    name: "description"
  }), __jsx("meta", {
    property: "og:url",
    content: "https://priceblocs.com".concat(router.asPath)
  }), __jsx("meta", {
    property: "og:type",
    content: meta.type
  }), __jsx("meta", {
    property: "og:site_name",
    content: "PriceBlocs"
  }), __jsx("meta", {
    property: "og:description",
    content: meta.description
  }), __jsx("meta", {
    property: "og:title",
    content: meta.title
  }), __jsx("meta", {
    property: "og:image",
    content: meta.image
  }), __jsx("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), __jsx("meta", {
    name: "twitter:site",
    content: "@priceblocs"
  }), __jsx("meta", {
    name: "twitter:title",
    content: meta.title
  }), __jsx("meta", {
    name: "twitter:description",
    content: meta.description
  }), __jsx("meta", {
    name: "twitter:image",
    content: meta.image
  }), meta.date && __jsx("meta", {
    property: "article:published_time",
    content: meta.date
  }));
};

/* harmony default export */ var Head = (Head_StaticHead);
// EXTERNAL MODULE: ./src/components/Nav/index.jsx + 44 modules
var components_Nav = __webpack_require__("5vWv");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/lodash/startCase.js
var startCase = __webpack_require__("50DI");
var startCase_default = /*#__PURE__*/__webpack_require__.n(startCase);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/components/Learn/Nav/index.jsx


var Nav_jsx = react_default.a.createElement;






var Nav_reduceConfigNodes = function reduceConfigNodes(_ref) {
  var config = _ref.config,
      activePath = _ref.activePath,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 1 : _ref$depth,
      onClick = _ref.onClick;
  return Object.keys(config).map(function (key) {
    var nodeConfig = config[key];
    var isLink = nodeConfig.href;

    if (isLink) {
      var _classnames;

      var isActive = activePath === nodeConfig.as;
      return !nodeConfig.disabled ? Nav_jsx(link_default.a, Object(esm_extends["a" /* default */])({}, nodeConfig, {
        key: nodeConfig.as
      }), Nav_jsx("a", {
        onClick: onClick,
        id: nodeConfig.as,
        className: classnames_default()("link decoration--hover db w-100 pv2 fw5 bg-white--hover f".concat(3 + depth), (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "ph".concat(depth - 1), depth > 2), Object(defineProperty["a" /* default */])(_classnames, "color-text--primary", !isActive), Object(defineProperty["a" /* default */])(_classnames, "underline fw6 color-primary link__decoration--hover", isActive), _classnames))
      }, startCase_default()(key))) : Nav_jsx("div", {
        key: nodeConfig.as,
        className: classnames_default()("db w-100 pv2 fw5 cursor-not-allowed black-40 f".concat(3 + depth), Object(defineProperty["a" /* default */])({}, "ph".concat(depth - 1), depth > 2))
      }, startCase_default()(key));
    } else if (typeof nodeConfig === "object") {
      return Nav_jsx("div", {
        className: classnames_default()("w-100 ".concat(key), {
          "pv3 bb hairline-1": depth === 1,
          "pt2": depth > 1
        }),
        key: key
      }, Nav_jsx("div", {
        className: classnames_default()("f".concat(3 + depth), Object(defineProperty["a" /* default */])({
          "fw6 pb1": depth === 1,
          "black-80 fw5 pb1": depth > 1
        }, "ph".concat(depth - 1), depth > 2))
      }, startCase_default()(key)), reduceConfigNodes({
        config: nodeConfig,
        activePath: activePath,
        depth: depth + 1,
        onClick: onClick
      }));
    }
  }, []);
};

var Nav_Nav = function Nav(_ref2) {
  var config = _ref2.config,
      onClick = _ref2.onClick;

  var _useRouter = Object(next_router["useRouter"])(),
      asPath = _useRouter.asPath;

  var nodes = Nav_reduceConfigNodes({
    config: config,
    activePath: asPath,
    onClick: onClick
  });
  return Nav_jsx("ul", {
    className: "list ma0 pa0 w-100 flex flex-column ph3"
  }, nodes);
};

/* harmony default export */ var Learn_Nav = (Nav_Nav);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./src/utils/styles.js
var styles = __webpack_require__("oCA+");

// EXTERNAL MODULE: ./src/components/IconButton/index.js
var IconButton = __webpack_require__("qhYS");

// EXTERNAL MODULE: ./src/components/Padder/index.jsx
var Padder = __webpack_require__("gH8l");

// EXTERNAL MODULE: ./src/utils/constants/ui.js + 1 modules
var ui = __webpack_require__("IWZK");

// EXTERNAL MODULE: ./src/utils/view.js
var view = __webpack_require__("x9nw");

// EXTERNAL MODULE: ./src/utils/route.js
var route = __webpack_require__("Fihp");

// CONCATENATED MODULE: ./src/components/Overlay/index.jsx








var Overlay_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }










var OFF_OVERLAY_CLASS = "offContent";
var DEFAULT_CLASSES = {
  container: "fixed w-100 top-0 bottom-0 right-0 left-0 z-7",
  overlay: "".concat(OFF_OVERLAY_CLASS, " w-100 h-100 relative"),
  content: "contentSection fixed absolute-l w-100 w-50-l top-0 right-0 bottom-0 bg-white bw2 b--black-10 shadow-0 overflow-y-scroll overflow-x-hidden",
  action: "fixed pa2 z-5 ba br2 hairline-1 bg-white bg-white--hover"
};

var Overlay_Overlay = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Overlay, _Component);

  var _super = _createSuper(Overlay);

  function Overlay() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Overlay);

    _this = _super.call(this);
    _this.hideOffContentClick = _this.hideOffContentClick.bind(Object(assertThisInitialized["a" /* default */])(_this));
    _this._overlayScroll = null;
    return _this;
  }
  /**
   * Reset scroll top when uuid changes
   * - important for mobile so that we dont get a fully scrolled down page
   * - which looks blank when navigating between models
   */


  Object(createClass["a" /* default */])(Overlay, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevUUID = prevProps.uuid,
          prevModelUUID = prevProps.modelUUID;
      var _this$props = this.props,
          uuid = _this$props.uuid,
          modelUUID = _this$props.modelUUID;
      var uuidChanged = prevUUID !== uuid;
      var modelUUIDChanged = prevModelUUID !== modelUUID;

      if (uuidChanged || modelUUIDChanged) {
        if (this._overlayScroll) {
          this._overlayScroll.scrollTop = 0;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Object(view["d" /* unfixBody */])();
    }
  }, {
    key: "hideOffContentClick",
    value: function hideOffContentClick(evt) {
      if (evt.target.classList.contains(OFF_OVERLAY_CLASS)) {
        var ctxHideOverlay = this.props.hideOverlay || route["c" /* hideOverlay */];
        ctxHideOverlay(this.props.router);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          customClasses = _this$props2.customClasses;

      var classes = _objectSpread(_objectSpread({}, DEFAULT_CLASSES), customClasses);

      var ctxHideOverlay = this.props.hideOverlay || route["c" /* hideOverlay */];
      var iconProps = {
        iconType: "close",
        iconProps: {
          size: 24
        },
        colors: {
          inactive: styles["a" /* COLORS */].primary
        },
        onClick: function onClick() {
          return ctxHideOverlay(_this2.props.router);
        }
      };
      return Overlay_jsx("div", {
        className: classes.container,
        style: {
          backgroundColor: "rgba(67, 90, 111, 0.7)"
        },
        onClick: this.hideOffContentClick
      }, Overlay_jsx("div", {
        className: classes.overlay
      }, Overlay_jsx("div", {
        style: ui["i" /* OVERFLOW_TOUCH */],
        ref: function ref(overlayScroll) {
          _this2._overlayScroll = overlayScroll;
        },
        className: style_default.a.dynamic([["2087710595", [ui["j" /* PHONE */] + 1]]]) + " " + (classes.content || "")
      }, Overlay_jsx("div", {
        style: {
          top: 8,
          right: 8
        },
        className: style_default.a.dynamic([["2087710595", [ui["j" /* PHONE */] + 1]]]) + " " + (classes.action || "")
      }, Overlay_jsx(IconButton["a" /* default */], iconProps)), children, Overlay_jsx(Padder["a" /* default */], {
        theme: "visible"
      }), Overlay_jsx(style_default.a, {
        id: "2087710595",
        dynamic: [ui["j" /* PHONE */] + 1]
      }, ["@media (min-width:".concat(ui["j" /* PHONE */] + 1, "px){.contentSection.__jsx-style-dynamic-selector{border-left-style:solid;}}")]))));
    }
  }]);

  return Overlay;
}(react["Component"]);

/* harmony default export */ var components_Overlay = (Object(next_router["withRouter"])(Overlay_Overlay));
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__("9rZX");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/utils/scroll.js




var scroll_Scroll = /*#__PURE__*/function () {
  function Scroll() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      y: 0
    };

    Object(classCallCheck["a" /* default */])(this, Scroll);

    this._scrollY = props.y;
  }

  Object(createClass["a" /* default */])(Scroll, [{
    key: "top",
    value: function top() {
      if (Object(view["c" /* isSm */])()) {
        /**
         * 1. Cache Y position first
         * 2. Then add class
         */
        this._scrollY = window && window.scrollY;
        this.fix && this.fix();
        this.to && this.to(0, 0);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      if (Object(view["c" /* isSm */])()) {
        /**
         * 1. Remove class
         * 2. Then reset Y position
         */
        this.unfix();
        this.to(0, this._scrollY);
      }
    }
    /**
     * Add fixed position class to help with overscroll position when mobile
     */

  }, {
    key: "fix",
    value: function fix() {
      this._scrollY = window && window.scrollY;
      Object(view["a" /* fixBody */])();
    }
    /**
    /**
     * Remove fixed position class
     */

  }, {
    key: "unfix",
    value: function unfix() {
      Object(view["d" /* unfixBody */])();
      this.to(0, this._scrollY);
    }
  }, {
    key: "to",
    value: function to() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
       true && window.scrollTo(x, y);
    }
  }]);

  return Scroll;
}();

/* harmony default export */ var utils_scroll = (scroll_Scroll);
var DESKTOP_SCROLL_CONTAINER = "desktopScrollContainer";
var scrollTopForId = function scrollTopForId(id) {
  if (typeof document !== "undefined") {
    var target = document.getElementById(id);

    if (target) {
      target.scrollTo(0, 0);
    }
  }
};
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__("D9Aj");

// CONCATENATED MODULE: ./src/components/Modal/componentStyles.js
var _defaultExport = [".modal__content{position:absolute;top:0px;left:0px;right:0px;bottom:0px;overflow:auto;-webkit-overflow-scrolling:touch;outline:none;}", ".modal__content--command{position:absolute;top:0px;left:0px;right:0px;bottom:0px;overflow:auto;-webkit-overflow-scrolling:touch;outline:none;-webkit-align-items:start !important;-webkit-box-align:start !important;-ms-flex-align:start !important;align-items:start !important;padding:14vh 16px 16px;}", ".modal__overlay{position:fixed;z-index:10;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.4);}", ".modal__overlay--command{position:fixed;z-index:10;top:0;left:0;right:0;bottom:0;background-color:rgba(256,256,256,0.5);}", ".modal__command--container{max-height:400px;box-shadow:0px 6px 20px rgb(0 0 0 / 20%);}", ".modal__command--containerVideo{box-shadow:0px 6px 20px rgb(0 0 0 / 20%);}", ".ReactModal__Content{opacity:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}", ".ReactModal__Content--after-open{opacity:1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", ".ReactModal__ContentCommand--after-open{opacity:1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:start;-webkit-box-align:start;-ms-flex-align:start;align-items:start;}", ".ReactModal__Content--before-close{opacity:0;}"];
_defaultExport.__hash = "3905955819";
/* harmony default export */ var componentStyles = (_defaultExport);
// CONCATENATED MODULE: ./src/utils/hooks/ui.js

var MOUSEDOWN = "mousedown";
var TOUCHSTART = "touchstart";
var ui_useOnClickOutside = function useOnClickOutside(ref, handler) {
  Object(react["useEffect"])(function () {
    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener(MOUSEDOWN, listener);
    document.addEventListener(TOUCHSTART, listener);
    return function () {
      document.removeEventListener(MOUSEDOWN, listener);
      document.removeEventListener(TOUCHSTART, listener);
    };
  }, [ref, handler]);
};
// CONCATENATED MODULE: ./src/components/Modal/index.jsx


var Modal_jsx = react_default.a.createElement;

function Modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Modal_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










lib_default.a.setAppElement("#root");
var Modal_DEFAULT_CLASSES = {
  modal: "modal__content br2-ns",
  overlay: "modal__overlay",
  container: "bg-white bn ba-ns br2-ns b--black-05 shadow-0 flex flex-column center w-100 h-100 h-auto-ns w-50-m w-40-l mw6 outline-1",
  action: "flex justify-end pt2 pr2"
};

var Modal_Modal = function Modal(props) {
  var containerRef = Object(react["useRef"])();
  var scroll = Object(react["useMemo"])(function () {
    return new utils_scroll();
  }, []);
  var onClose = props.onClose;

  var _useState = Object(react["useState"])(props.showModal || false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  Object(react["useEffect"])(function () {
    if (props.showModal !== showModal) {
      setShowModal(props.showModal);
    }
  }, [props.showModal]);

  var showRoutine = function showRoutine() {
    Object(crisp["b" /* crispHide */])();
    Object(view["c" /* isSm */])() && scroll.fix();
  };

  var hideRoutine = function hideRoutine() {
    scroll.unfix();
    Object(crisp["c" /* crispShow */])();
    onClose && onClose();
  };

  Object(react["useEffect"])(function () {
    showModal ? showRoutine() : hideRoutine();
  }, [showModal]);

  var handleCloseModal = function handleCloseModal() {
    hideRoutine();
    setShowModal(false);
  };

  var hideOnClickOutside = Object(react["useCallback"])(function () {
    handleCloseModal();
  }, []);
  ui_useOnClickOutside(containerRef, hideOnClickOutside);
  var showCloseIcon = props.showCloseIcon,
      customClasses = props.customClasses;

  var classes = Modal_objectSpread(Modal_objectSpread({}, Modal_DEFAULT_CLASSES), customClasses);

  var iconProps = {
    iconType: "close",
    iconProps: {
      size: 26
    },
    colors: {
      hover: styles["a" /* COLORS */].text,
      active: styles["a" /* COLORS */].text,
      inactive: styles["a" /* COLORS */].text
    },
    onClick: handleCloseModal
  };
  return Modal_jsx(lib_default.a, {
    className: classes.modal,
    overlayClassName: classes.overlay,
    closeTimeoutMS: 0,
    isOpen: showModal,
    onRequestClose: handleCloseModal,
    contentLabel: "PriceBlocs modal",
    shouldCloseOnOverlayClick: true
  }, Modal_jsx("div", {
    ref: containerRef,
    className: "jsx-".concat(componentStyles.__hash) + " " + (classes.container || "")
  }, showCloseIcon && Modal_jsx("div", {
    className: "jsx-".concat(componentStyles.__hash) + " " + (classes.action || "")
  }, Modal_jsx(IconButton["a" /* default */], iconProps)), props.children), Modal_jsx(style_default.a, {
    id: componentStyles.__hash
  }, componentStyles));
};

/* harmony default export */ var components_Modal = (Modal_Modal);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__("i8i4");
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./src/utils/context/command.js
var command = __webpack_require__("7L7P");

// CONCATENATED MODULE: ./node_modules/compute-scroll-into-view/dist/index.module.js
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}/* harmony default export */ var index_module = (function(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p)}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else{F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)))}C.push({el:k,top:F,left:G})}return C});
//# sourceMappingURL=index.module.js.map

// CONCATENATED MODULE: ./node_modules/scroll-into-view-if-needed/es/index.js


function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(isTargetAttached ? index_module(target, options) : []);
  }

  if (!isTargetAttached) {
    return;
  }

  var computeOptions = getOptions(options);
  return defaultBehavior(index_module(target, computeOptions), computeOptions.behavior);
}

/* harmony default export */ var es = (scrollIntoView);
// CONCATENATED MODULE: ./node_modules/smooth-scroll-into-view-if-needed/es/index.js

var memoizedNow;

var now = function now() {
  if (!memoizedNow) {
    memoizedNow = 'performance' in window ? performance.now.bind(performance) : Date.now;
  }

  return memoizedNow();
};

function step(context) {
  var time = now();
  var elapsed = Math.min((time - context.startTime) / context.duration, 1);
  var value = context.ease(elapsed);
  var currentX = context.startX + (context.x - context.startX) * value;
  var currentY = context.startY + (context.y - context.startY) * value;
  context.method(currentX, currentY);

  if (currentX !== context.x || currentY !== context.y) {
    requestAnimationFrame(function () {
      return step(context);
    });
  } else {
    context.cb();
  }
}

function smoothScroll(el, x, y, duration, ease, cb) {
  if (duration === void 0) {
    duration = 600;
  }

  if (ease === void 0) {
    ease = function ease(t) {
      return 1 + --t * t * t * t * t;
    };
  }

  var scrollable;
  var startX;
  var startY;
  var method;
  scrollable = el;
  startX = el.scrollLeft;
  startY = el.scrollTop;

  method = function method(x, y) {
    el.scrollLeft = Math.ceil(x);
    el.scrollTop = Math.ceil(y);
  };

  step({
    scrollable: scrollable,
    method: method,
    startTime: now(),
    startX: startX,
    startY: startY,
    x: x,
    y: y,
    duration: duration,
    ease: ease,
    cb: cb
  });
}

var shouldSmoothScroll = function shouldSmoothScroll(options) {
  return options && !options.behavior || options.behavior === 'smooth';
};

function es_scroll(target, options) {
  var overrides = options || {};

  if (shouldSmoothScroll(overrides)) {
    return es(target, {
      block: overrides.block,
      inline: overrides.inline,
      scrollMode: overrides.scrollMode,
      boundary: overrides.boundary,
      behavior: function behavior(actions) {
        return Promise.all(actions.reduce(function (results, _ref) {
          var el = _ref.el,
              left = _ref.left,
              top = _ref.top;
          var startLeft = el.scrollLeft;
          var startTop = el.scrollTop;

          if (startLeft === left && startTop === top) {
            return results;
          }

          return [].concat(results, [new Promise(function (resolve) {
            return smoothScroll(el, left, top, overrides.duration, overrides.ease, function () {
              return resolve({
                el: el,
                left: [startLeft, left],
                top: [startTop, top]
              });
            });
          })]);
        }, []));
      }
    });
  }

  return Promise.resolve(es(target, options));
}

var smoothScrollIntoView = es_scroll;
/* harmony default export */ var smooth_scroll_into_view_if_needed_es = (smoothScrollIntoView);
// EXTERNAL MODULE: ./src/components/FormerEditor/utils.js + 1 modules
var utils = __webpack_require__("Mlyw");

// EXTERNAL MODULE: ./src/utils/action.js
var action = __webpack_require__("EN2D");

// CONCATENATED MODULE: ./src/components/CommandPalette/Trigger.jsx


var _STATUS_CLASSES, _STATUS_COLORS;

var Trigger_jsx = react_default.a.createElement;

function Trigger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Trigger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Trigger_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Trigger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var DEFAULT_COPY = "Menu";
var Trigger_DEFAULT_CLASSES = {
  container: "flex flex-row pointer items-center ba bg-white bg-white--hover br2 ph2 pv1 f6 fw5",
  copy: "pr1",
  suffix: "dib pl1 ml1 bl flex"
};
var STATUS_CLASSES = (_STATUS_CLASSES = {}, Object(defineProperty["a" /* default */])(_STATUS_CLASSES, ui["m" /* STATUS */].DEFAULT, "b--primary color-primary"), Object(defineProperty["a" /* default */])(_STATUS_CLASSES, ui["m" /* STATUS */].NEUTRAL, "b--black-30 bg-white--hover color-secondary black-70"), _STATUS_CLASSES);
var STATUS_COLORS = (_STATUS_COLORS = {}, Object(defineProperty["a" /* default */])(_STATUS_COLORS, ui["m" /* STATUS */].DEFAULT, styles["a" /* COLORS */].blue), Object(defineProperty["a" /* default */])(_STATUS_COLORS, ui["m" /* STATUS */].NEUTRAL, styles["a" /* COLORS */].primary), _STATUS_COLORS);

var Trigger_Trigger = function Trigger(_ref) {
  var onClick = _ref.onClick,
      copy = _ref.copy,
      icon = _ref.icon,
      customClasses = _ref.customClasses,
      status = _ref.status;

  var classes = Trigger_objectSpread(Trigger_objectSpread({}, Trigger_DEFAULT_CLASSES), customClasses);

  var ctxCopy = copy || DEFAULT_COPY;
  var Icon = Object(utils["a" /* getIconForUID */])(icon);
  var ctxStatus = status || ui["m" /* STATUS */].DEFAULT;
  var statusClasses = STATUS_CLASSES[ctxStatus];
  var statusColor = STATUS_COLORS[ctxStatus];
  return Trigger_jsx("div", {
    className: "".concat(classes.container, " ").concat(statusClasses),
    onClick: onClick || action["a" /* NO_OP */]
  }, Trigger_jsx("div", {
    className: classes.copy
  }, Trigger_jsx("div", null, ctxCopy)), Trigger_jsx("div", {
    className: "".concat(classes.suffix, " ").concat(statusClasses)
  }, icon ? Trigger_jsx(Icon, {
    size: 16,
    color: statusColor
  }) : Trigger_jsx("div", null, "\u2318K")));
};

/* harmony default export */ var CommandPalette_Trigger = (Trigger_Trigger);
// CONCATENATED MODULE: ./src/constants/keycode.js
// https://css-tricks.com/snippets/javascript/javascript-keycodes/
var KEYCODE_MAP = {
  BACKSPACE: 8,
  UP_ARROW: 38,
  DOWN_ARROW: 40,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32
};
// EXTERNAL MODULE: ./src/components/CommandPalette/constants.js
var constants = __webpack_require__("VSLR");

// EXTERNAL MODULE: ./src/components/Form/fields/constants.js
var fields_constants = __webpack_require__("eLLw");

// CONCATENATED MODULE: ./src/components/CommandPalette/QueryInput.jsx

var QueryInput_jsx = react_default.a.createElement;

function QueryInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function QueryInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { QueryInput_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { QueryInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var QueryInput_QueryInput = function QueryInput() {
  var queryRef = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    queryRef.current && queryRef.current.focus();
  }, []);

  var _useCommandContext = Object(command["c" /* useCommandContext */])(),
      values = _useCommandContext.values,
      setFieldValue = _useCommandContext.setFieldValue,
      activeId = _useCommandContext.activeId,
      _useCommandContext$ac = _useCommandContext.actions,
      popHistory = _useCommandContext$ac.popHistory,
      incrementIndex = _useCommandContext$ac.incrementIndex,
      decrementIndex = _useCommandContext$ac.decrementIndex,
      performIndex = _useCommandContext$ac.performIndex;

  var currentIndex = values.index,
      query = values.query;
  /**
   * Reset index on query change
   */

  Object(react["useEffect"])(function () {
    if (currentIndex) {
      setFieldValue("index", 0);
    }
  }, [query]);

  var resetQueryAndFocus = function resetQueryAndFocus() {
    setFieldValue("query", "");

    if (queryRef && queryRef.current) {
      queryRef.current.value = "";
      queryRef.current.focus();
    }
  };
  /**
   * Reset query on activeId change
   * - click on item without a perform
   * - or backspace on when theres no query value
   */


  Object(react["useEffect"])(function () {
    resetQueryAndFocus();
  }, [activeId]);
  var onKeyDown = Object(react["useCallback"])(function (evt) {
    var isBackspace = evt.keyCode === KEYCODE_MAP.BACKSPACE;
    var searchIsEmpty = queryRef && queryRef.current && !queryRef.current.value;
    var navigateBack = isBackspace && searchIsEmpty;

    if (navigateBack) {
      popHistory();
    } else if (evt.keyCode === KEYCODE_MAP.UP_ARROW) {
      decrementIndex();
    } else if (evt.keyCode === KEYCODE_MAP.DOWN_ARROW) {
      incrementIndex();
    } else if (evt.keyCode === KEYCODE_MAP.ENTER) {
      performIndex();
    }
  }, [values]);

  var inputProps = QueryInput_objectSpread(QueryInput_objectSpread({
    ref: queryRef,
    className: "input--muted f5 fw5 black-80 border-box input-reset ba pa3 db w-100 lh-copy bn brtl-2 brtr-2 absolute top-0 left-0 right-0",
    style: constants["a" /* BORDER_STYLE */],
    type: "text",
    name: "text",
    onKeyDown: onKeyDown,

    /**
     * Note: used to used debounceOnChange here
     */
    onChange: function onChange(evt) {
      return setFieldValue("query", evt.currentTarget.value);
    }
  }, fields_constants["a" /* AUTO_ATTRS */]), {}, {
    placeholder: "Search..."
  });

  return QueryInput_jsx("input", inputProps);
};

/* harmony default export */ var CommandPalette_QueryInput = (QueryInput_QueryInput);
// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__("gQMU");
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);

// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__("7tbW");
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// CONCATENATED MODULE: ./src/components/CommandPalette/utils.js


function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { utils_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var utils_getItemProps = function getItemProps(_ref) {
  var item = _ref.item,
      index = _ref.index,
      currentIndex = _ref.currentIndex,
      onClick = _ref.onClick,
      afterClick = _ref.afterClick,
      actions = _ref.actions;
  var refVal = index - 1;
  var focused = refVal === currentIndex;
  var result = {
    tabIndex: index,
    id: "command-item-".concat(index),
    key: item.id,
    className: classnames_default()("w-100 pa3 bg-white--hover pointer", {
      "bg-whitesmoke": focused
    }),
    style: utils_objectSpread(utils_objectSpread({}, constants["a" /* BORDER_STYLE */]), {}, {
      borderColor: focused ? "black" : "transparent"
    })
  };

  if (item.perform) {
    if (item.perform.type) {
      var performAction = actions[item.perform.type];

      if (performAction) {
        result.onClick = function () {
          actions[item.perform.type](item.perform.props);
          afterClick && setTimeout(afterClick, 0);
        };
      } else {
        console.error("Unsupported perform type: ".concat(item.perform.type, ". Make sure ").concat(item.perform.type, " has a corresponding key within actions."));
      }
    } else if (typeof item.perform === "function") {
      result.onClick = function () {
        item.perform();
        afterClick && setTimeout(afterClick, 0);
      };
    } else {
      console.error("Invalid perform configuration", item.perform);
    }
  } else if (onClick) {
    result.onClick = onClick;
  }

  return result;
};
var utils_getBreadcrumbs = function getBreadcrumbs(_ref2) {
  var item = _ref2.item,
      commandsMap = _ref2.commandsMap;
  var result;
  var parts = [];

  if (item.parent) {
    var parent = commandsMap[item.parent];

    if (parent.section) {
      parts.push(parent.section);
    }

    if (parent.name) {
      parts.push(parent.name);
    }
  }

  if (item.section) {
    parts.push(item.section);
  }

  result = uniq_default()(parts).map(function (part) {
    return upperFirst_default()(part);
  }).join(" > ");

  if (result) {
    result += " >";
  }

  return result;
};
// CONCATENATED MODULE: ./src/components/CommandPalette/Item.jsx
var Item_jsx = react_default.a.createElement;





var Item_Item = function Item(_ref) {
  var item = _ref.item,
      index = _ref.index;

  var _useCommandContext = Object(command["c" /* useCommandContext */])(),
      values = _useCommandContext.values,
      actions = _useCommandContext.actions;

  var addHistory = actions.addHistory;
  var reset = actions.reset;
  var itemProps = utils_getItemProps({
    item: item,
    index: index,
    currentIndex: values.index,

    /**
     * Note: this is the default onClick handler
     * - Can be override by a more specific perform handler on the item
     */
    onClick: function onClick() {
      addHistory(item.id);
    },
    afterClick: reset,
    actions: actions
  });
  var iconNode;
  var Icon = item.type && constants["d" /* COMMAND_TYPE_ICON_MAP */][item.type];

  if (Icon) {
    iconNode = Item_jsx("div", {
      className: "fr"
    }, Item_jsx(Icon, {
      size: 20
    }));
  }

  return Item_jsx("div", itemProps, item.name, iconNode);
};

/* harmony default export */ var CommandPalette_Item = (Item_Item);
// CONCATENATED MODULE: ./src/components/CommandPalette/Suggestion.jsx
var Suggestion_jsx = react_default.a.createElement;





var Suggestion_Suggestion = function Suggestion(_ref) {
  var item = _ref.item,
      index = _ref.index;

  var _useCommandContext = Object(command["c" /* useCommandContext */])(),
      values = _useCommandContext.values,
      commandsMap = _useCommandContext.commandsMap,
      actions = _useCommandContext.actions;

  var addHistory = actions.addHistory;
  var reset = actions.reset;
  var itemProps = utils_getItemProps({
    item: item,
    index: index,
    currentIndex: values.index,
    onClick: function onClick() {
      addHistory(item.id);
    },
    afterClick: reset,
    actions: actions
  });
  var breadcrumbs = utils_getBreadcrumbs({
    item: item,
    commandsMap: commandsMap
  });
  var iconNode;
  var Icon = item.type && constants["d" /* COMMAND_TYPE_ICON_MAP */][item.type];

  if (Icon) {
    iconNode = Suggestion_jsx("div", {
      className: "fr"
    }, Suggestion_jsx(Icon, {
      size: 20
    }));
  }

  return Suggestion_jsx("div", itemProps, breadcrumbs && Suggestion_jsx("span", {
    key: item.id,
    className: "black-50 pr1"
  }, breadcrumbs), item.name, iconNode);
};

/* harmony default export */ var CommandPalette_Suggestion = (Suggestion_Suggestion);
// EXTERNAL MODULE: ./src/components/HoverIconButton/index.jsx + 5 modules
var HoverIconButton = __webpack_require__("gDcV");

// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__("X4fA");

// EXTERNAL MODULE: ./src/components/LoadingSpinner/index.jsx + 1 modules
var LoadingSpinner = __webpack_require__("a/D+");

// EXTERNAL MODULE: ./src/components/VideoEmbed/index.jsx + 4 modules
var VideoEmbed = __webpack_require__("5ULk");

// CONCATENATED MODULE: ./src/components/CommandPalette/CommandVideoEmbed.jsx
var CommandVideoEmbed_jsx = react_default.a.createElement;




var CommandVideoEmbed_useOnKeydown = function useOnKeydown(ref, handler) {
  Object(react["useEffect"])(function () {
    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("keydown", listener);
    return function () {
      document.removeEventListener("keydown", listener);
    };
  }, [ref, handler]);
};

var CommandVideoEmbed_CommandVideoEmbed = function CommandVideoEmbed(props) {
  var _useCommandContext = Object(command["c" /* useCommandContext */])(),
      popHistory = _useCommandContext.actions.popHistory;

  var ref = Object(react["useRef"])(null);

  var handleKeydown = function handleKeydown(evt) {
    var goBack = evt.keyCode === KEYCODE_MAP.BACKSPACE || evt.keyCode === KEYCODE_MAP.ESCAPE;

    if (goBack) {
      popHistory();
    }
  };

  var onKeydown = Object(react["useCallback"])(function (evt) {
    handleKeydown(evt);
  }, []);
  CommandVideoEmbed_useOnKeydown(ref, onKeydown);
  return CommandVideoEmbed_jsx("span", {
    ref: ref
  }, CommandVideoEmbed_jsx(VideoEmbed["a" /* default */], props));
};

/* harmony default export */ var CommandPalette_CommandVideoEmbed = (CommandVideoEmbed_CommandVideoEmbed);
// EXTERNAL MODULE: ./src/utils/command.js + 1 modules
var utils_command = __webpack_require__("sc12");

// CONCATENATED MODULE: ./src/components/CommandPalette/index.jsx
var CommandPalette_jsx = react_default.a.createElement;
















var COMMAND_ITEM = "command-item";

var getItemId = function getItemId(index) {
  return "".concat(COMMAND_ITEM, "-").concat(index);
};

var CommandPalette_CommandPaletteContent = function CommandPaletteContent() {
  var ref = Object(react["useRef"])();

  var _useCommandContext = Object(command["c" /* useCommandContext */])(),
      _useCommandContext$va = _useCommandContext.values,
      query = _useCommandContext$va.query,
      index = _useCommandContext$va.index,
      debug = _useCommandContext$va.debug,
      loading = _useCommandContext.loading,
      activeId = _useCommandContext.activeId,
      sections = _useCommandContext.sections,
      suggestions = _useCommandContext.suggestions,
      _useCommandContext$ac = _useCommandContext.actions,
      addHistory = _useCommandContext$ac.addHistory,
      popHistory = _useCommandContext$ac.popHistory,
      reset = _useCommandContext$ac.reset,
      activeCommand = _useCommandContext.activeCommand;
  /**
   * Close on click outside
   */


  var hideMenu = Object(react["useCallback"])(function () {
    return reset();
  }, []);
  ui_useOnClickOutside(ref, hideMenu);
  /**
   * Scroll command item into view on index change
   * - i.e. on keyboard up | down we update index
   */

  Object(react["useEffect"])(function () {
    var activeItem = document.getElementById(getItemId(index));

    if (activeItem) {
      smooth_scroll_into_view_if_needed_es(activeItem, {
        behavior: "smooth",
        scrollMode: "always",
        block: "center"
      });
    }
  }, [index]);
  var indexCounter = 0;
  var nodes = [CommandPalette_jsx("div", {
    key: "padder",
    id: getItemId(indexCounter),
    tabIndex: 0,
    style: {
      height: constants["g" /* PADDER_HEIGHT */],
      backgroundColor: "transparent"
    },
    className: "w-100"
  })];

  for (var section in sections) {
    var hasSectionName = section && section !== "undefined";

    if (hasSectionName) {
      var sectionIdKey = [section];

      if (activeId) {
        sectionIdKey.push(activeId);
      }

      nodes.push(CommandPalette_jsx("div", {
        key: sectionIdKey.join("-"),
        className: "f7 ttu pv2 ph3 fw6",
        style: constants["a" /* BORDER_STYLE */]
      }, section));
    }

    var items = sections[section];

    if (Array.isArray(items)) {
      items.forEach(function (item) {
        indexCounter++;
        nodes.push(CommandPalette_jsx(CommandPalette_Item, {
          key: item.id,
          item: item,
          index: indexCounter,
          addHistory: addHistory,
          reset: reset
        }));
      });
    }
  }

  if (Array.isArray(suggestions) && suggestions.length) {
    nodes.push(CommandPalette_jsx("div", {
      key: "suggestions",
      className: "f7 ttu pv2 ph3 fw6",
      style: constants["a" /* BORDER_STYLE */]
    }, "Suggestions"));
    suggestions.forEach(function (item) {
      indexCounter++;
      nodes.push(CommandPalette_jsx(CommandPalette_Suggestion, {
        key: item.id,
        item: item,
        index: indexCounter,
        addHistory: addHistory,
        reset: reset
      }));
    });
  }

  var isVideo = activeCommand && activeCommand.type === constants["c" /* COMMAND_TYPE */].VIDEO;
  var content = isVideo ? CommandPalette_jsx(CommandPalette_CommandVideoEmbed, activeCommand.config, CommandPalette_jsx("div", {
    className: "absolute left-0 top-0 h-100 flex items-center"
  }, CommandPalette_jsx(HoverIconButton["a" /* default */], {
    size: 22,
    icon: "back",
    onClick: popHistory
  }))) : CommandPalette_jsx(react["Fragment"], null, debug && CommandPalette_jsx("div", {
    className: "f7 z-1 absolute top-0 left-0"
  }, query), loading && CommandPalette_jsx("div", {
    style: {
      top: 18
    },
    className: "absolute top-0 right-1 bottom-0 z-1"
  }, CommandPalette_jsx(LoadingSpinner["a" /* default */], {
    customClasses: {
      ring: "blue",
      size: "small"
    }
  })), CommandPalette_jsx(CommandPalette_QueryInput, null), CommandPalette_jsx("div", {
    style: {
      maxHeight: constants["f" /* MAX_HEIGHT */]
    },
    className: "w-100 overflow-y-scroll"
  }, nodes));
  return CommandPalette_jsx("div", {
    ref: ref,
    className: "w-100 overflow-hidden relative"
  }, content);
};

var CommandPalette_CommandPaletteContainer = function CommandPaletteContainer(_ref) {
  var trigger = _ref.trigger;

  var _useCommandContext2 = Object(command["c" /* useCommandContext */])(),
      open = _useCommandContext2.values.open,
      activeCommand = _useCommandContext2.activeCommand,
      setOpen = _useCommandContext2.actions.setOpen;

  var isVideo = activeCommand && activeCommand.type === constants["c" /* COMMAND_TYPE */].VIDEO;
  var triggerNode = null;
  var triggerProps = {
    onClick: function onClick() {
      return setOpen(true);
    }
  };

  if (trigger) {
    /**
     * Apply minimum onClick handler
     */
    triggerNode = !trigger.props.onClick ? /*#__PURE__*/react_default.a.cloneElement(trigger, triggerProps) : trigger;
  } else {
    triggerNode = CommandPalette_jsx(CommandPalette_Trigger, triggerProps);
  }

  return CommandPalette_jsx(react["Fragment"], null, triggerNode, open ? /*#__PURE__*/react_dom_default.a.createPortal(CommandPalette_jsx(components_Modal, {
    showModal: open,
    showCloseIcon: false,
    onClose: function onClose() {
      return setOpen(false);
    },
    customClasses: Object(utils_command["a" /* getCommandModalClasses */])({
      isVideo: isVideo
    })
  }, CommandPalette_jsx(CommandPalette_CommandPaletteContent, null)), document.body) : null);
};

var CommandPalette_CommandPalette = function CommandPalette(_ref2) {
  var commands = _ref2.commands,
      id = _ref2.id,
      actions = _ref2.actions,
      initialValues = _ref2.initialValues,
      trigger = _ref2.trigger,
      preventKeyboardTrigger = _ref2.preventKeyboardTrigger;
  var providerProps = {
    actions: actions,
    commands: commands,
    initialValues: initialValues,
    preventKeyboardTrigger: preventKeyboardTrigger,
    apiKey: Object(auth["d" /* getJWT */])()
  };

  if (id) {
    providerProps.id = id;
  }

  return CommandPalette_jsx(command["a" /* CommandContextProvider */], providerProps, CommandPalette_jsx(CommandPalette_CommandPaletteContainer, {
    trigger: trigger
  }));
};

/* harmony default export */ var components_CommandPalette = (CommandPalette_CommandPalette);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 5 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__("RBan");
var last_default = /*#__PURE__*/__webpack_require__.n(last);

// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__("wig9");
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);

// EXTERNAL MODULE: ./src/data/learnNavConfig.json
var learnNavConfig = __webpack_require__("zGSJ");

// CONCATENATED MODULE: ./src/utils/hooks/command.js



function command_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function command_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { command_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { command_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var NAVIGATE = "navigate";
var PERFORM_TYPE = {
  NAVIGATE: NAVIGATE
};

var command_sanitizeKey = function sanitizeKey(key) {
  return upperFirst_default()(key).replace(/-/g, " ");
};

var command_routeConfigToCommands = function routeConfigToCommands(_ref) {
  var config = _ref.config,
      _ref$parentKey = _ref.parentKey,
      parentKey = _ref$parentKey === void 0 ? "" : _ref$parentKey;
  var result = [];

  for (var key in config) {
    var keyConfig = config[key];
    var isRouteConfig = keyConfig && keyConfig.href;
    var mergedParentKey = compact_default()([parentKey, key]).join(".");
    var mergedParentKeyParts = mergedParentKey.split(".");
    var hasMultipleIdParts = mergedParentKeyParts.length > 1;
    var parentKeyParts = parentKey.split(".");
    var hasParent = parentKeyParts.length > 1;
    var commandProps = {
      id: mergedParentKey,
      parent: hasParent ? parentKey : null,
      section: command_sanitizeKey(last_default()(parentKeyParts))
    };

    if (isRouteConfig) {
      result.push(command_objectSpread(command_objectSpread({}, commandProps), {}, {
        name: command_sanitizeKey(key),
        perform: {
          type: PERFORM_TYPE.NAVIGATE,
          props: {
            href: keyConfig.href,
            as: keyConfig.as
          }
        }
      }));
    } else if (keyConfig) {
      if (hasMultipleIdParts) {
        result.push(command_objectSpread(command_objectSpread({}, commandProps), {}, {
          name: command_sanitizeKey(last_default()(mergedParentKeyParts))
        }));
      }

      result = result.concat(routeConfigToCommands({
        config: keyConfig,
        parentKey: mergedParentKey
      }));
    }
  }

  return result;
};
var command_useCommands = function useCommands() {
  var routeActions = command_routeConfigToCommands({
    config: learnNavConfig
  });
  return Object(toConsumableArray["a" /* default */])(routeActions);
};
// EXTERNAL MODULE: ./src/utils/context/index.js
var context = __webpack_require__("jMmE");

// CONCATENATED MODULE: ./src/components/Static/Container/index.jsx

var Container_jsx = react_default.a.createElement;













var MENU_WIDTH = 240;
var SIDEBAR_STYLES = {
  position: "fixed",
  top: 0,
  left: 0,
  marginTop: 52,
  display: "flex",
  flexDirection: "column",
  width: MENU_WIDTH,
  minWidth: MENU_WIDTH,
  height: "100%",
  maxHeight: "100vh"
};
var SIDEBAR_NAV_STYLES = {
  flex: "1 1 0%",
  overflowY: "auto",
  marginBottom: "10px"
};
var CONTAINER_STYLES = {
  position: "relative",
  overflow: "hidden",
  marginLeft: MENU_WIDTH,
  maxWidth: "100%"
};
var MAIN_STYLE = {
  marginTop: 52,
  height: "calc(100vh - 3.5rem)",
  overflowY: "auto",
  overflowX: "hidden"
};

var Container_StaticContainer = function StaticContainer(_ref) {
  var meta = _ref.meta,
      index = _ref.index,
      footer = _ref.footer,
      show = _ref.show,
      children = _ref.children,
      navConfig = _ref.navConfig;

  var _useViewport = Object(context["d" /* useViewport */])(),
      isSmall = _useViewport.isSmall;

  var _useState = Object(react["useState"])(false),
      showOverlay = _useState[0],
      setShowOverlay = _useState[1];

  var showDocsMenu = function showDocsMenu() {
    return setShowOverlay(true);
  };

  var hideDocsMenu = function hideDocsMenu() {
    setShowOverlay(false);
  };

  var commands = command_useCommands();
  /**
   * Prepare custom actions with navigate
   */

  var _useRouter = Object(next_router["useRouter"])(),
      push = _useRouter.push;

  var actions = Object(defineProperty["a" /* default */])({}, PERFORM_TYPE.NAVIGATE, function (_ref2) {
    var href = _ref2.href,
        to = _ref2.as;
    push(href, to, {
      shallow: false
    });
  });

  var navMenu = Container_jsx(Learn_Nav, {
    onClick: hideDocsMenu,
    config: navConfig
  });

  var indexLink = Container_jsx("div", {
    className: "pa3 bb hairline-1 flex flex-row justify-between"
  }, Container_jsx(link_default.a, {
    key: "indexLink",
    asPath: index.path,
    href: index.path
  }, Container_jsx(HoverIconButton["a" /* default */], {
    customClasses: {
      button: "ma0 items-center flex pa0 dib items-center justify-center bn br1 panel--action relative"
    },
    color: styles["a" /* COLORS */].blue,
    type: "home",
    size: 22
  })), Container_jsx(components_CommandPalette, {
    actions: actions,
    commands: commands,
    trigger: Container_jsx(CommandPalette_Trigger, {
      copy: "Search"
    })
  }));

  var footerLabel = Container_jsx("div", {
    className: "pa3 bt hairline-1 flex items-center justify-center"
  }, Container_jsx("div", {
    className: "f5"
  }, footer.label));

  return Container_jsx(react["Fragment"], null, Container_jsx(Head, {
    meta: meta
  }), Container_jsx(react["Fragment"], null, Container_jsx(components_Nav["a" /* default */], null)), !isSmall && Container_jsx("main", {
    id: "skip",
    className: "flex-l dn",
    style: MAIN_STYLE
  }, Container_jsx("div", {
    className: "fixed top-0 left-0 bottom-0 right-0 bg-white bh--inset z-1",
    style: SIDEBAR_STYLES
  }, indexLink, Container_jsx("nav", {
    className: "docs--nav__desktop",
    style: SIDEBAR_NAV_STYLES
  }, navMenu), footerLabel), Container_jsx("div", {
    className: "flex flex-column w-100 ph4 bg-white",
    style: CONTAINER_STYLES
  }, children)), isSmall && Container_jsx("main", {
    id: "skip",
    className: "flex flex-column dn-l ph3 pt5"
  }, Container_jsx("div", {
    className: "flex flex-row items-center pt3 mw7 justify-start",
    onClick: showDocsMenu
  }, Container_jsx(HoverIconButton["a" /* default */], {
    type: "list"
  }), Container_jsx("div", {
    className: "f6 pl2 fw5"
  }, show.label)), children), showOverlay && Container_jsx(components_Overlay, {
    hideOverlay: function hideOverlay() {
      return setShowOverlay(false);
    }
  }, Container_jsx("div", {
    className: "pt3"
  }, indexLink, Container_jsx("nav", {
    className: "docs--nav__mobile"
  }, navMenu), footerLabel)));
};

/* harmony default export */ var Container = (Container_StaticContainer);
// CONCATENATED MODULE: ./src/components/Learn/Container/index.jsx



var Learn_Container_jsx = react_default.a.createElement;

function Container_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Container_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Container_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Container_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Container_DocsContainer = function DocsContainer(props) {
  var children = props.children,
      navConfig = props.navConfig,
      posts = props.posts,
      customMeta = Object(objectWithoutProperties["a" /* default */])(props, ["children", "navConfig", "posts"]);

  var meta = Container_objectSpread({
    title: "Learn - PriceBlocs",
    description: "Learn about how to get setup with PriceBlocs and sell in any channel with payment links.",
    image: "https://priceblocs.com/meta/og-image-primary.png",
    type: "website"
  }, customMeta);

  var containerProps = {
    index: {
      label: "Learn",
      path: "/"
    },
    show: {
      label: "Show learn menu"
    },
    footer: {
      label: "Made with ♥️"
    },
    children: children,
    navConfig: navConfig,
    meta: meta
  };
  return Learn_Container_jsx(Container, Object(esm_extends["a" /* default */])({
    key: "docs-container"
  }, containerProps));
};

/* harmony default export */ var Learn_Container = __webpack_exports__["a"] = (Container_DocsContainer);

/***/ }),

/***/ "Mlyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getIconForUID; });

// UNUSED EXPORTS: SECTIONS, getEditorInitialValues

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./src/components/FormerEditor/common/index.js + 1 modules
var common = __webpack_require__("KMwo");

// EXTERNAL MODULE: ./src/components/FormerEditor/common/template.js
var template = __webpack_require__("MTWH");

// EXTERNAL MODULE: ./src/components/FormerEditor/common/constants/entity.js
var entity = __webpack_require__("X7rx");

// EXTERNAL MODULE: ./node_modules/@hacknug/react-icons/ri/index.esm.js
var index_esm = __webpack_require__("KOF7");

// EXTERNAL MODULE: ./node_modules/@hacknug/react-icons/vsc/index.esm.js
var vsc_index_esm = __webpack_require__("k+hw");

// EXTERNAL MODULE: ./node_modules/@hacknug/react-icons/io/index.esm.js
var io_index_esm = __webpack_require__("nKjC");

// EXTERNAL MODULE: ./node_modules/@hacknug/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__("ywmy");

// EXTERNAL MODULE: ./src/utils/constants/state.js
var state = __webpack_require__("6MV9");

// CONCATENATED MODULE: ./src/utils/constants/builder.js
var ENTITY_ADD = "entity_add";
var ENTITY_SETTINGS = "entity_settings";
var PAGE_THEME = "page_theme";
var BUILDER_INTENT = {
  ENTITY_ADD: ENTITY_ADD,
  ENTITY_SETTINGS: ENTITY_SETTINGS,
  PAGE_THEME: PAGE_THEME
};
var BUILDER_ENTITY = {
  ENTITY_ADD: ENTITY_ADD,
  PAGE_THEME: PAGE_THEME
};
var BLOCK_LIST_WIDTH = 240;
var BLOCK_SETTINGS_WIDTH = 500;
var BLOCK_SECTION_NAV = 56;
var HUB_SIDEBAR_NAV_WIDTH = 180;
var BLOCK_REGISTRY = {
  SCROLL_CONTAINER: "scroll-container"
};
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("mwIZ");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/components/FormerEditor/common/constants/index.js
var constants = __webpack_require__("5oF3");

// EXTERNAL MODULE: ./src/utils/constants/navigation.js
var navigation = __webpack_require__("PZOY");

// CONCATENATED MODULE: ./src/components/FormerEditor/utils.js


var _ICON_MAP;




 // import { AiOutlineNotification } from "@hacknug/react-icons/ai";









var PAGE_BUILDER = "page-builder";
var SETTINGS = "settings";
var FEATURES = "features";
var PRODUCTS = "products";
var SECTIONS = {
  PAGE_BUILDER: PAGE_BUILDER,
  SETTINGS: SETTINGS,
  FEATURES: FEATURES,
  PRODUCTS: PRODUCTS
};
/**
 * Source documentation:
 * https://react-icons.github.io/react-icons/icons?name=ri
 */

var ICON_MAP = (_ICON_MAP = {}, Object(defineProperty["a" /* default */])(_ICON_MAP, entity["a" /* default */].NAVIGATION, index_esm["L" /* RiMapPinLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, entity["a" /* default */].FOOTER, index_esm["hb" /* RiStopLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, entity["a" /* default */].BANNER, index_esm["A" /* RiFlag2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, entity["a" /* default */].PRICING_TABLE, index_esm["jb" /* RiTableLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, entity["a" /* default */].FEATURE_COMPARISON, index_esm["o" /* RiCheckboxMultipleLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, SECTIONS.PAGE_BUILDER, index_esm["S" /* RiPencilLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, SECTIONS.SETTINGS, index_esm["db" /* RiSettingsLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, SECTIONS.FEATURES, index_esm["z" /* RiFileListLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, SECTIONS.PRODUCTS, index_esm["W" /* RiPriceTag3Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, constants["l" /* RECURRING_INTERVALS */].MONTH, index_esm["m" /* RiCalendarEventLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, constants["l" /* RECURRING_INTERVALS */].YEAR, index_esm["l" /* RiCalendarCheckLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "application", index_esm["t" /* RiDatabase2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "coupons", index_esm["s" /* RiCoupon3Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "upload", index_esm["lb" /* RiUploadCloud2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "discount", index_esm["V" /* RiPriceTag3Fill */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "medal", index_esm["M" /* RiMedalLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "shield", index_esm["eb" /* RiShieldCheckLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "gear", index_esm["cb" /* RiSettings2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "search", index_esm["bb" /* RiSearchLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "grid", index_esm["H" /* RiLayoutGridLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "list", index_esm["N" /* RiMenu2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "checkmark", io_index_esm["a" /* IoIosCheckmarkCircle */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "checkmarkCircle", index_esm["n" /* RiCheckboxCircleLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "refresh", index_esm["ab" /* RiRefreshLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "close", index_esm["q" /* RiCloseLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "addImage", index_esm["F" /* RiImageAddLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "external", io_index_esm["c" /* IoMdOpen */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "delete", index_esm["u" /* RiDeleteBin7Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "help", index_esm["G" /* RiInformationLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "question", index_esm["Z" /* RiQuestionLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "add", index_esm["a" /* RiAddLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "down", index_esm["d" /* RiArrowDownSLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "right", index_esm["g" /* RiArrowRightSLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "rightArrow", index_esm["f" /* RiArrowRightLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "up", index_esm["h" /* RiArrowUpSLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "dragDrop", index_esm["v" /* RiDragDropLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "back", index_esm["e" /* RiArrowLeftLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "forward", index_esm["f" /* RiArrowRightLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "code", index_esm["r" /* RiCodeSSlashLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "copy", index_esm["p" /* RiClipboardLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "edit", index_esm["w" /* RiEdit2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "eye", index_esm["x" /* RiEyeLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "eyeClosed", index_esm["y" /* RiEyeOffLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "star", index_esm["fb" /* RiStarLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "lock", index_esm["K" /* RiLock2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "flash", index_esm["B" /* RiFlashlightLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "alert", index_esm["c" /* RiAlertLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "more", index_esm["Q" /* RiMoreLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "theme", index_esm["R" /* RiPaletteLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "dollar", index_esm["O" /* RiMoneyDollarBoxLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "sales", index_esm["O" /* RiMoneyDollarBoxLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "store", index_esm["ib" /* RiStore2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "bank", index_esm["i" /* RiBankLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "globe", index_esm["C" /* RiGlobalLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "individual", index_esm["mb" /* RiUserLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "group", index_esm["D" /* RiGroupLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "calculator", index_esm["k" /* RiCalculatorLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "warning", io_index_esm["b" /* IoIosWarning */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "alarm", index_esm["b" /* RiAlarmWarningLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "chart", index_esm["j" /* RiBarChartBoxLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "link", index_esm["J" /* RiLinksFill */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "taxRates", index_esm["T" /* RiPercentLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "fallback", index_esm["P" /* RiMoreFill */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "time", index_esm["kb" /* RiTimerLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "qrCode", index_esm["X" /* RiQrCodeLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "scan", index_esm["Y" /* RiQrScan2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "shipping", fa_index_esm["a" /* FaShippingFast */]), Object(defineProperty["a" /* default */])(_ICON_MAP, navigation["a" /* HUB_APP_SUB_SECTION */].ANALYTICS, index_esm["I" /* RiLineChartLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, navigation["a" /* HUB_APP_SUB_SECTION */].PAGES, index_esm["gb" /* RiStickyNoteLine */]), Object(defineProperty["a" /* default */])(_ICON_MAP, navigation["a" /* HUB_APP_SUB_SECTION */].HOME, index_esm["E" /* RiHome4Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, navigation["a" /* HUB_APP_SUB_SECTION */].LINKS, index_esm["J" /* RiLinksFill */]), Object(defineProperty["a" /* default */])(_ICON_MAP, navigation["a" /* HUB_APP_SUB_SECTION */].FILES, index_esm["lb" /* RiUploadCloud2Line */]), Object(defineProperty["a" /* default */])(_ICON_MAP, navigation["a" /* HUB_APP_SUB_SECTION */].CAMPAIGNS, vsc_index_esm["a" /* VscMegaphone */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "link_builder", index_esm["J" /* RiLinksFill */]), Object(defineProperty["a" /* default */])(_ICON_MAP, "page_builder", index_esm["gb" /* RiStickyNoteLine */]), _ICON_MAP);
var getIconForUID = function getIconForUID(uid) {
  var icon = ICON_MAP[uid];

  if (!icon) {
    if (false) {}

    icon = ICON_MAP.fallback;
  }

  return icon;
};
var utils_getEditorInitialValues = function getEditorInitialValues(_ref) {
  var manifest = _ref.manifest,
      admin = _ref.admin,
      theme = _ref.theme,
      products = _ref.products,
      prices = _ref.prices,
      features = _ref.features,
      featureGroups = _ref.featureGroups,
      appEntities = _ref.appEntities,
      variables = _ref.variables;
  var input = {
    manifest: manifest,
    admin: admin,
    products: products,
    prices: prices,
    features: features,
    featureGroups: featureGroups,
    appEntities: appEntities
  };
  var generatedVariables = Object(template["a" /* generateVariableSet */])({
    persisted: variables,
    template: [],
    product: products,
    price: prices
  });
  var hydratedVariables = Object(template["b" /* getHydratedVariables */])(generatedVariables, {
    product: products,
    price: prices
  });
  var isBlank = get_default()(input, state["a" /* STATE_KEYS */].MANIFEST.ENTITIES, []).length === 0;
  var preparedManifest = Object(common["b" /* prepareManifestForEditor */])(input);
  return {
    editor: {
      intent: isBlank ? BUILDER_INTENT.ENTITY_ADD : null,
      activeSection: SECTIONS.PAGE_BUILDER,
      activeBlock: null,
      visibility: {
        panel: !!isBlank
      },
      pricing: {
        activeProduct: null,
        activePrice: null,
        intent: null
      },
      feature: {
        activeProduct: null,
        intent: null
      }
    },
    manifest: preparedManifest,
    theme: theme,
    variables: hydratedVariables
  };
};

/***/ }),

/***/ "QEso":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("q1tI");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("17x9");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__("VKEO");

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__("S1to");

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__("Ye7m");

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__("fbhf");

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__("2zs7");

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__("UIKY");

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__("WkvU");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            id: id,
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ "S1to":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__("ZDLa");

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ "UIKY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports.default = portalOpenInstances;
module.exports = exports["default"];

/***/ }),

/***/ "VCL8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ "VKEO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__("ZDLa");

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ "VSLR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BORDER_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMMAND_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MAX_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PADDER_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMMAND_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return YOU_TUBE_EMBED_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFAULT_SERVICE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMMAND_TYPE_ICON_MAP; });
/* unused harmony export COMMAND_CONTENT_ID */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var _hacknug_react_icons_ri__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KOF7");


var _DEFAULT_SERVICE_CONF;


var BORDER_STYLE = {
  borderTopWidth: 0,
  borderBottomWidth: 0,
  borderRightWidth: 0,
  borderLeftWidth: 2,
  borderStyle: "solid",
  borderColor: "transparent"
};
var VIDEO = "video";
var COMMAND_TYPE = {
  VIDEO: VIDEO
};
var MAX_HEIGHT = 400;
var PADDER_HEIGHT = 54;
var LOOM = "loom";
var NOTION = "notion";
var YOU_TUBE = "youtube";
var COMMAND_SERVICE = {
  LOOM: LOOM,
  YOU_TUBE: YOU_TUBE,
  NOTION: NOTION
};
var LOOM_CONFIG = {};
var YOU_TUBE_CONFIG = {
  //   adNetwork={true} // Default true, to preconnect or not to doubleclick addresses called by YouTube iframe (the adnetwork from Google)
  params: "",
  // any params you want to pass to the URL, assume we already had '&' and pass your parameters string
  playlist: false,
  // Use  true when your ID be from a playlist
  poster: "hqdefault",
  // Defines the image size to call on first render as poster image. Possible values are "default","mqdefault",  "hqdefault", "sddefault" and "maxresdefault". Default value for this prop is "hqdefault". Please be aware that "sddefault" and "maxresdefault", high resolution images are not always avaialble for every video. See: https://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
  title: "YouTube Embed",
  // a11y, always provide a title for iFrames: https://dequeuniversity.com/tips/provide-iframe-titles Help the web be accessible ;)
  noCookie: true // Default false, connect to YouTube via the Privacy-Enhanced Mode using https://www.youtube-nocookie.com

};
var YOU_TUBE_EMBED_KEYS = [// Default true, to preconnect or not to doubleclick addresses called by YouTube iframe (the adnetwork from Google)
"adNetwork", // any params you want to pass to the URL, assume we already had '&' and pass your parameters string
"params", // Use  true when your ID be from a playlist
"playlist", // Defines the image size to call on first render as poster image. Possible values are "default","mqdefault",  "hqdefault", "sddefault" and "maxresdefault". Default value for this prop is "hqdefault". Please be aware that "sddefault" and "maxresdefault", high resolution images are not always avaialble for every video. See: https://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
"poster", // a11y, always provide a title for iFrames: https://dequeuniversity.com/tips/provide-iframe-titles Help the web be accessible ;)
"title", // Default false, connect to YouTube via the Privacy-Enhanced Mode using https://www.youtube-nocookie.com
"noCookie"];
var DEFAULT_SERVICE_CONFIG = (_DEFAULT_SERVICE_CONF = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_DEFAULT_SERVICE_CONF, COMMAND_SERVICE.YOU_TUBE, YOU_TUBE_CONFIG), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_DEFAULT_SERVICE_CONF, COMMAND_SERVICE.LOOM, LOOM_CONFIG), _DEFAULT_SERVICE_CONF);
var COMMAND_TYPE_ICON_MAP = {
  video: _hacknug_react_icons_ri__WEBPACK_IMPORTED_MODULE_1__[/* RiPlayCircleLine */ "U"]
};
var COMMAND_CONTENT_ID = {
  PLACEHOLDER: "a6d360b6-f9cd-44d6-a252-fda714fd60d0",
  FUNDAMENTALS: {
    ADD_A_FIELD: "ef78a639-00c5-4ffb-a335-fb270b6d549f",
    ADD_A_PRODUCT: "998458f3-09f5-48b4-9665-ee0c0ad6d0bf",
    FIRST_PAGE: "65ec9fba-7b7a-40fb-b677-24d03b330415",
    BUILD_A_FORM: "5818a663-9bdb-4d4c-87be-436e89906b3a"
  },
  CHECKOUT: {
    /**
     * Needs:
     * - product settings
     */
    // DEFAULT_CONFIG: "a6d360b6-f9cd-44d6-a252-fda714fd60d0",
    // COMMON_CONFIG: "a6d360b6-f9cd-44d6-a252-fda714fd60d0",
    // LOGIC_SETTINGS: "a6d360b6-f9cd-44d6-a252-fda714fd60d0",
    COUPON: "6da9d4c5-fe94-4b43-b95b-cf494345a6df",
    CONNECT_PROMOTION_CODE_SETTINGS: "eb46a356-a6dd-49ca-9c12-566f2e638198",
    COMBINATION_LOGIC: "1ea6e979-c5a4-45f9-8ed7-05fcc7a4474d",
    LOGIC: "e13e56be-8f02-4cba-b9b4-28472ee6a758",
    SETUP_FIELD_COMBINATIONS: "d43b8c70-3fc0-4d34-8b70-bea7da4396c3"
  },
  FIELDS: {
    STANDARD_SETTINGS: "62df14cf-64ee-42b7-b51f-eb7b97e15394",
    CONNECT_EMAIL_SETTINGS: "6d17e97e-41bc-4187-94ff-8586bd83672a",
    PREFILL_AND_CONNECT: "16aac5c3-e6eb-4537-9287-cb08a5c147c4",
    COMBINATION_UPSELL: "0c7522af-b1eb-4ff5-88a7-6c547393a3b0",
    // PREFILL_SETTINGS: "a6d360b6-f9cd-44d6-a252-fda714fd60d0",
    // CONNECT_SETTINGS: "a6d360b6-f9cd-44d6-a252-fda714fd60d0",
    CONNECT_PROMOTION_CODE_SETTINGS: "b874ca05-502f-4057-9f29-e40ce1732066"
  },
  EDITOR: {
    THEME: "44cd3b51-56e2-4e31-86ac-f8f0016b3454",
    REORDER_FIELDS: "fd32fe42-9436-430f-9fd0-d3949cbcb1aa"
  },
  WEBFLOW: {
    EMBED: "52ecb8a1-2662-4987-a989-16202317ea7a"
  },
  EMBED: {
    STYLE_LAYOUT: "fdfcd31b-cd96-46bf-9104-9b02a1c83288",
    PARAMETERS_FORWARD: "21590b5f-01fa-4852-8af5-d1c9483cb03a",
    HOSTING_ALLOWED_DOMAINS: "db49f524-fa98-44c0-a845-7e2244b1fd19" // Forward cancel url and success_url

  },
  ZAPIER: {
    APP: "c896d2d4-422c-48f4-846b-70e14e6afe38",
    CREATE_A_WORKFLOW: "8bcd439a-fecc-4e67-aa96-e7a0e860a325",
    AUTHENTICATE: "f0965e76-00d0-480c-8ac1-8f84fa45e25f",
    FORMAT_FILTER: "f3dbd732-749e-4760-b47c-678daea6e0e0",
    FORMAT_LABELED_DICTIONARY: "754948c2-0eb0-49ab-9fb9-6b50b2f0a5a4"
  },
  API: {
    CHECKOUT: "a6445c27-77af-4f6c-8408-6f5adfc47519"
  }
};

/***/ }),

/***/ "WkvU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _portalOpenInstances = __webpack_require__("UIKY");

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ "Ye7m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__("2W6z");

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__("2zs7");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),

/***/ "ZDLa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ "fbhf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) { var _x, x, buffer, classes; }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ "gDcV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/FormerEditor/utils.js + 1 modules
var utils = __webpack_require__("Mlyw");

// EXTERNAL MODULE: ./src/utils/styles.js
var styles = __webpack_require__("oCA+");

// EXTERNAL MODULE: ./src/components/LoadingSpinner/index.jsx + 1 modules
var LoadingSpinner = __webpack_require__("a/D+");

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/react-tooltip/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

function rng() {
  if (!getRandomValues) {
    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
  }

  return getRandomValues(rnds8);
}
// CONCATENATED MODULE: ./node_modules/react-tooltip/node_modules/uuid/dist/esm-browser/bytesToUuid.js
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];

for (var bytesToUuid_i = 0; bytesToUuid_i < 256; ++bytesToUuid_i) {
  byteToHex[bytesToUuid_i] = (bytesToUuid_i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

/* harmony default export */ var esm_browser_bytesToUuid = (bytesToUuid);
// CONCATENATED MODULE: ./node_modules/react-tooltip/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || esm_browser_bytesToUuid(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// CONCATENATED MODULE: ./node_modules/react-tooltip/dist/index.es.js
function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}





function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var CONSTANT = {
  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/**
 * Static methods for react-tooltip
 */

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatible with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
  var event;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, {
      detail: opts
    });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true, opts);
  }

  window.dispatchEvent(event);
};

function staticMethods (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
      target: target
    });
  };
  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */


  target.rebuild = function () {
    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
  };
  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */


  target.show = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
      target: target
    });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false; // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY

      this.showTooltip({
        currentTarget: hasTarget && event.detail.target
      }, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({
        currentTarget: hasTarget && event.detail.target
      }, hasTarget);
    }
  };
}

/**
 * Events that should be bound to the window
 */
function windowListener (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild

    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show

    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize

    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };
  /**
   * invoked by resize event of window
   */


  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
}

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */
var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;
  var isCapture = this.isCapture(e.currentTarget);
  var currentItem = e.currentTarget.getAttribute('currentItem');
  if (!isCapture) e.stopPropagation();

  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListeners = {
  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
  set: function set(target, event, listener) {
    if (this.id in target) {
      var map = target[this.id];
      map[event] = listener;
    } else {
      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty({}, event, listener)
      });
    }
  },
  get: function get(target, event) {
    var map = target[this.id];

    if (map !== undefined) {
      return map[event];
    }
  }
};
function customEvent (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;
    return event || !!ele.getAttribute('data-event');
  };
  /* Bind listener for custom event */


  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff;
    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListeners.get(ele, event));
      var customListener = checkStatus.bind(_this, dataEventOff);
      customListeners.set(ele, event, customListener);
      ele.addEventListener(event, customListener, false);
    });

    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };
  /* Unbind listener for custom event */


  target.prototype.customUnbindListener = function (ele) {
    var _this$state2 = this.state,
        event = _this$state2.event,
        eventOff = _this$state2.eventOff;
    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
}

/**
 * Util method to judge if it should follow capture model
 */
function isCapture (target) {
  target.prototype.isCapture = function (currentTarget) {
    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
  };
}

/**
 * Util method to get effect
 */
function getEffect (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
}

/**
 * Util method to get effect
 */

var makeProxy = function makeProxy(e) {
  var proxy = {};

  for (var key in e) {
    if (typeof e[key] === 'function') {
      proxy[key] = e[key].bind(e);
    } else {
      proxy[key] = e[key];
    }
  }

  return proxy;
};

var bodyListener = function bodyListener(callback, options, e) {
  var _options$respectEffec = options.respectEffect,
      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
      _options$customEvent = options.customEvent,
      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
  var id = this.props.id;
  var tip = e.target.getAttribute('data-tip') || null;
  var forId = e.target.getAttribute('data-for') || null;
  var target = e.target;

  if (this.isCustomEvent(target) && !customEvent) {
    return;
  }

  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;

  if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
    var proxy = makeProxy(e);
    proxy.currentTarget = target;
    callback(proxy);
  }
};

var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
  var events = {};
  targetArray.forEach(function (target) {
    var event = target.getAttribute(dataAttribute);
    if (event) event.split(' ').forEach(function (event) {
      return events[event] = true;
    });
  });
  return events;
};

var getBody = function getBody() {
  return document.getElementsByTagName('body')[0];
};

function bodyMode (target) {
  target.prototype.isBodyMode = function () {
    return !!this.props.bodyMode;
  };

  target.prototype.bindBodyListener = function (targetArray) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff,
        possibleCustomEvents = _this$state.possibleCustomEvents,
        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
    var body = getBody();
    var customEvents = findCustomEvents(targetArray, 'data-event');
    var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
    if (event != null) customEvents[event] = true;
    if (eventOff != null) customEventsOff[eventOff] = true;
    possibleCustomEvents.split(' ').forEach(function (event) {
      return customEvents[event] = true;
    });
    possibleCustomEventsOff.split(' ').forEach(function (event) {
      return customEventsOff[event] = true;
    });
    this.unbindBodyListener(body);
    var listeners = this.bodyModeListeners = {};

    if (event == null) {
      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
        respectEffect: true
      });
      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
    }

    for (var _event in customEvents) {
      listeners[_event] = bodyListener.bind(this, function (e) {
        var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
        checkStatus.call(_this, targetEventOff, e);
      }, {
        customEvent: true
      });
    }

    for (var _event2 in customEventsOff) {
      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
        customEvent: true
      });
    }

    for (var _event3 in listeners) {
      body.addEventListener(_event3, listeners[_event3]);
    }
  };

  target.prototype.unbindBodyListener = function (body) {
    body = body || getBody();
    var listeners = this.bodyModeListeners;

    for (var event in listeners) {
      body.removeEventListener(event, listeners[event]);
    }
  };
}

/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */
// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

function trackRemoval (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;
    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];

        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];

          if (element === _this.state.currentTarget) {
            _this.hideTooltip();

            return;
          }
        }
      }
    });
    observer.observe(window.document, {
      childList: true,
      subtree: true
    });
    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
}

/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */
function getPosition (e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node),
      tipWidth = _getDimensions.width,
      tipHeight = _getDimensions.height;

  var _getDimensions2 = getDimensions(target),
      targetWidth = _getDimensions2.width,
      targetHeight = _getDimensions2.height;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffsetX = _calculateOffset.extraOffsetX,
      extraOffsetY = _calculateOffset.extraOffsetY;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offsetX = defaultOffset[place].l;
    return mouseX + offsetX + extraOffsetX;
  };

  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offsetX = defaultOffset[place].r;
    return mouseX + offsetX + extraOffsetX;
  };

  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offsetY = defaultOffset[place].t;
    return mouseY + offsetY + extraOffsetY;
  };

  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offsetY = defaultOffset[place].b;
    return mouseY + offsetY + extraOffsetY;
  }; //
  // Functions to test whether the tooltip's sides are inside
  // the client window for a given orientation p
  //
  //  _____________
  // |             | <-- Right side
  // | p = 'left'  |\
  // |             |/  |\
  // |_____________|   |_\  <-- Mouse
  //      / \           |
  //       |
  //       |
  //  Bottom side
  //


  var outsideLeft = function outsideLeft(p) {
    return getTipOffsetLeft(p) < 0;
  };

  var outsideRight = function outsideRight(p) {
    return getTipOffsetRight(p) > windowWidth;
  };

  var outsideTop = function outsideTop(p) {
    return getTipOffsetTop(p) < 0;
  };

  var outsideBottom = function outsideBottom(p) {
    return getTipOffsetBottom(p) > windowHeight;
  }; // Check whether the tooltip with orientation p is completely inside the client window


  var outside = function outside(p) {
    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
  };

  var inside = function inside(p) {
    return !outside(p);
  };

  var placesList = ['top', 'bottom', 'left', 'right'];
  var insideList = [];

  for (var i = 0; i < 4; i++) {
    var p = placesList[i];

    if (inside(p)) {
      insideList.push(p);
    }
  }

  var isNewState = false;
  var newPlace;
  var shouldUpdatePlace = desiredPlace !== place;

  if (inside(desiredPlace) && shouldUpdatePlace) {
    isNewState = true;
    newPlace = desiredPlace;
  } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
    isNewState = true;
    newPlace = insideList[0];
  }

  if (isNewState) {
    return {
      isNewState: true,
      newState: {
        place: newPlace
      }
    };
  }

  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
}

var getDimensions = function getDimensions(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      height = _node$getBoundingClie.height,
      width = _node$getBoundingClie.width;

  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
}; // Get current mouse offset


var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;

  var _getDimensions3 = getDimensions(currentTarget),
      targetWidth = _getDimensions3.width,
      targetHeight = _getDimensions3.height;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }

  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window


var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top;
  var right;
  var bottom;
  var left;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right
  };
}; // Consider additional offset into position calculation


var calculateOffset = function calculateOffset(offset) {
  var extraOffsetX = 0;
  var extraOffsetY = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/'/g, '"'));
  }

  for (var key in offset) {
    if (key === 'top') {
      extraOffsetY -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffsetY += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffsetX -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffsetX += parseInt(offset[key], 10);
    }
  }

  return {
    extraOffsetX: extraOffsetX,
    extraOffsetY: extraOffsetY
  };
}; // Get the offset of the parent elements


var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;

  while (currentParent) {
    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
  return {
    parentTop: parentTop,
    parentLeft: parentLeft
  };
};

/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */
function getTipContent (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.

  if (getContent === null) return null; // Tip not exist and children is null or undefined

  var regexp = /<br\s*\/?>/;

  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  } // Multiline tooltip content


  return tip.split(regexp).map(function (d, i) {
    return react_default.a.createElement("span", {
      key: i,
      className: "multi-line"
    }, d);
  });
}

/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return /(^aria-\w+$|^role$)/.test(prop);
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });
  return ariaObj;
}

/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */
function nodeListToArray (nodeList) {
  var length = nodeList.length;

  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }

  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
}

function generateUUID() {
  return 't' + esm_browser_v4();
}

___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}");

/**
 * Default pop-up style values (text color, background color).
 */
var defaultColors = {
  dark: {
    text: '#fff',
    background: '#222',
    border: 'transparent',
    arrow: '#222'
  },
  success: {
    text: '#fff',
    background: '#8DC572',
    border: 'transparent',
    arrow: '#8DC572'
  },
  warning: {
    text: '#fff',
    background: '#F0AD4E',
    border: 'transparent',
    arrow: '#F0AD4E'
  },
  error: {
    text: '#fff',
    background: '#BE6464',
    border: 'transparent',
    arrow: '#BE6464'
  },
  info: {
    text: '#fff',
    background: '#337AB7',
    border: 'transparent',
    arrow: '#337AB7'
  },
  light: {
    text: '#222',
    background: '#fff',
    border: 'transparent',
    arrow: '#fff'
  }
};
function getDefaultPopupColors(type) {
  return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : undefined;
}

/**
 * Generates the specific tooltip style for use on render.
 */

function generateTooltipStyle(uuid, customColors, type, hasBorder) {
  return generateStyle(uuid, getPopupColors(customColors, type, hasBorder));
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */

function generateStyle(uuid, colors) {
  var textColor = colors.text;
  var backgroundColor = colors.background;
  var borderColor = colors.border;
  var arrowColor = colors.arrow;
  return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        border-top: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(arrowColor, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(arrowColor, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        border-left: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(arrowColor, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        border-right: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(arrowColor, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ");
}

function getPopupColors(customColors, type, hasBorder) {
  var textColor = customColors.text;
  var backgroundColor = customColors.background;
  var borderColor = customColors.border;
  var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
  var colors = getDefaultPopupColors(type);

  if (textColor) {
    colors.text = textColor;
  }

  if (backgroundColor) {
    colors.background = backgroundColor;
  }

  if (hasBorder) {
    if (borderColor) {
      colors.border = borderColor;
    } else {
      colors.border = type === 'light' ? 'black' : 'white';
    }
  }

  if (arrowColor) {
    colors.arrow = arrowColor;
  }

  return colors;
}

var _class, _class2, _temp;

var index_es_ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactTooltip, _React$Component);

  _createClass(ReactTooltip, null, [{
    key: "propTypes",
    get: function get() {
      return {
        uuid: prop_types_default.a.string,
        children: prop_types_default.a.any,
        place: prop_types_default.a.string,
        type: prop_types_default.a.string,
        effect: prop_types_default.a.string,
        offset: prop_types_default.a.object,
        multiline: prop_types_default.a.bool,
        border: prop_types_default.a.bool,
        textColor: prop_types_default.a.string,
        backgroundColor: prop_types_default.a.string,
        borderColor: prop_types_default.a.string,
        arrowColor: prop_types_default.a.string,
        insecure: prop_types_default.a.bool,
        "class": prop_types_default.a.string,
        className: prop_types_default.a.string,
        id: prop_types_default.a.string,
        html: prop_types_default.a.bool,
        delayHide: prop_types_default.a.number,
        delayUpdate: prop_types_default.a.number,
        delayShow: prop_types_default.a.number,
        event: prop_types_default.a.string,
        eventOff: prop_types_default.a.string,
        isCapture: prop_types_default.a.bool,
        globalEventOff: prop_types_default.a.string,
        getContent: prop_types_default.a.any,
        afterShow: prop_types_default.a.func,
        afterHide: prop_types_default.a.func,
        overridePosition: prop_types_default.a.func,
        disable: prop_types_default.a.bool,
        scrollHide: prop_types_default.a.bool,
        resizeHide: prop_types_default.a.bool,
        wrapper: prop_types_default.a.string,
        bodyMode: prop_types_default.a.bool,
        possibleCustomEvents: prop_types_default.a.string,
        possibleCustomEventsOff: prop_types_default.a.string,
        clickable: prop_types_default.a.bool
      };
    }
  }]);

  function ReactTooltip(props) {
    var _this;

    _classCallCheck(this, ReactTooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
    _this.state = {
      uuid: props.uuid || generateUUID(),
      place: props.place || 'top',
      // Direction of tooltip
      desiredPlace: props.place || 'top',
      type: 'dark',
      // Color theme of tooltip
      effect: 'float',
      // float or fixed
      show: false,
      border: false,
      customColors: {},
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null,
      // Current mouse event
      currentTarget: null,
      // Current target of mouse event
      ariaProps: parseAria(props),
      // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      possibleCustomEvents: props.possibleCustomEvents || '',
      possibleCustomEventsOff: props.possibleCustomEventsOff || '',
      originTooltip: null,
      isMultiline: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'hideTooltipOnScroll', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.delayReshow = null;
    _this.intervalUpdateContent = null;
    return _this;
  }
  /**
   * For unify the bind and unbind listener
   */


  _createClass(ReactTooltip, [{
    key: "bind",
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          insecure = _this$props.insecure,
          resizeHide = _this$props.resizeHide;
      this.bindListener(); // Bind listener for tooltip

      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mount = false;
      this.clearTimer();
      this.unbindListener();
      this.removeScrollListener(this.state.currentTarget);
      this.unbindWindowEvents();
    }
    /**
     * Return if the mouse is on the tooltip.
     * @returns {boolean} true - mouse is on the tooltip
     */

  }, {
    key: "mouseOnToolTip",
    value: function mouseOnToolTip() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        /* old IE or Firefox work around */
        if (!this.tooltipRef.matches) {
          /* old IE work around */
          if (this.tooltipRef.msMatchesSelector) {
            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
          } else {
            /* old Firefox work around */
            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
          }
        }

        return this.tooltipRef.matches(':hover');
      }

      return false;
    }
    /**
     * Pick out corresponded target elements
     */

  }, {
    key: "getTargetArray",
    value: function getTargetArray(id) {
      var targetArray = [];
      var selector;

      if (!id) {
        selector = '[data-tip]:not([data-for])';
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
      } // Scan document for shadow DOM elements


      nodeListToArray(document.getElementsByTagName('*')).filter(function (element) {
        return element.shadowRoot;
      }).forEach(function (element) {
        targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
      });
      return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
    }
    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: "bindListener",
    value: function bindListener() {
      var _this3 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          globalEventOff = _this$props2.globalEventOff,
          isCapture = _this$props2.isCapture;
      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }

        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customUnbindListener(target);
        }
      });

      if (this.isBodyMode()) {
        this.bindBodyListener(targetArray);
      } else {
        targetArray.forEach(function (target) {
          var isCaptureMode = _this3.isCapture(target);

          var effect = _this3.getEffect(target);

          if (_this3.isCustomEvent(target)) {
            _this3.customBindListener(target);

            return;
          }

          target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);

          if (effect === 'float') {
            target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
          }

          target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
        });
      } // Global event to hide tooltip


      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
      } // Track removal of targetArray elements from DOM


      this.bindRemovalTracker();
    }
    /**
     * Unbind listeners on target elements
     */

  }, {
    key: "unbindListener",
    value: function unbindListener() {
      var _this4 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          globalEventOff = _this$props3.globalEventOff;

      if (this.isBodyMode()) {
        this.unbindBodyListener();
      } else {
        var targetArray = this.getTargetArray(id);
        targetArray.forEach(function (target) {
          _this4.unbindBasicListener(target);

          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
        });
      }

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }
    /**
     * Invoke this before bind listener and unmount the component
     * it is necessary to invoke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: "unbindBasicListener",
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent() {
      var _this$props4 = this.props,
          getContent = _this$props4.getContent,
          children = _this$props4.children; // Generate tooltip content

      var content;

      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }

      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: "isEmptyTip",
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
    }
    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: "showTooltip",
    value: function showTooltip(e, isGlobalCall) {
      if (!this.tooltipRef) {
        return;
      }

      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement) return;
      } // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected


      var _this$props5 = this.props,
          multiline = _this$props5.multiline,
          getContent = _this$props5.getContent;
      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect

      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll

      var scrollHide = true;

      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      } // Make sure the correct place is set


      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      }

      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering

      this.clearTimer();
      var target = e.currentTarget;
      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
      var self = this;

      var updateState = function updateState() {
        self.setState({
          originTooltip: originTooltip,
          isMultiline: isMultiline,
          desiredPlace: desiredPlace,
          place: place,
          type: target.getAttribute('data-type') || self.props.type || 'dark',
          customColors: {
            text: target.getAttribute('data-text-color') || self.props.textColor || null,
            background: target.getAttribute('data-background-color') || self.props.backgroundColor || null,
            border: target.getAttribute('data-border-color') || self.props.borderColor || null,
            arrow: target.getAttribute('data-arrow-color') || self.props.arrowColor || null
          },
          effect: effect,
          offset: offset,
          html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html) || false,
          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
          border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border) || false,
          extraClass: target.getAttribute('data-class') || self.props["class"] || self.props.className || '',
          disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable) || false,
          currentTarget: target
        }, function () {
          if (scrollHide) {
            self.addScrollListener(self.state.currentTarget);
          }

          self.updateTooltip(e);

          if (getContent && Array.isArray(getContent)) {
            self.intervalUpdateContent = setInterval(function () {
              if (self.mount) {
                var _getContent = self.props.getContent;
                var placeholder = getTipContent(originTooltip, '', _getContent[0](), isMultiline);
                var isEmptyTip = self.isEmptyTip(placeholder);
                self.setState({
                  isEmptyTip: isEmptyTip
                });
                self.updatePosition();
              }
            }, getContent[1]);
          }
        });
      }; // If there is no delay call immediately, don't allow events to get in first.


      if (reshowDelay) {
        this.delayReshow = setTimeout(updateState, reshowDelay);
      } else {
        updateState();
      }
    }
    /**
     * When mouse hover, update tool tip
     */

  }, {
    key: "updateTooltip",
    value: function updateTooltip(e) {
      var _this5 = this;

      var _this$state = this.state,
          delayShow = _this$state.delayShow,
          disable = _this$state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.getTooltipContent();
      var delayTime = parseInt(delayShow, 10);
      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

      if (this.mouseOnToolTip()) {
        return;
      } // if the tooltip is empty, disable the tooltip


      if (this.isEmptyTip(placeholder) || disable) {
        return;
      }

      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this5.state.show;

          _this5.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this5.updatePosition();

            if (isInvisible && afterShow) {
              afterShow(e);
            }
          });
        }
      };

      clearTimeout(this.delayShowLoop);

      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }
    /*
     * If we're mousing over the tooltip remove it when we leave.
     */

  }, {
    key: "listenForTooltipExit",
    value: function listenForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
      }
    }
  }, {
    key: "removeListenerForTooltipExit",
    value: function removeListenerForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
      }
    }
    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: "hideTooltip",
    value: function hideTooltip(e, hasTarget) {
      var _this6 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        isScroll: false
      };
      var disable = this.state.disable;
      var isScroll = options.isScroll;
      var delayHide = isScroll ? 0 : this.state.delayHide;
      var afterHide = this.props.afterHide;
      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip

      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }

      var resetState = function resetState() {
        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

        if (_this6.mouseOnToolTip()) {
          _this6.listenForTooltipExit();

          return;
        }

        _this6.removeListenerForTooltipExit();

        _this6.setState({
          show: false
        }, function () {
          _this6.removeScrollListener(_this6.state.currentTarget);

          if (isVisible && afterHide) {
            afterHide(e);
          }
        });
      };

      this.clearTimer();

      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }
    /**
     * When scroll, hide tooltip
     */

  }, {
    key: "hideTooltipOnScroll",
    value: function hideTooltipOnScroll(event, hasTarget) {
      this.hideTooltip(event, hasTarget, {
        isScroll: true
      });
    }
    /**
     * Add scroll event listener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: "addScrollListener",
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
    } // Calculation the position

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var _this7 = this;

      var _this$state2 = this.state,
          currentEvent = _this$state2.currentEvent,
          currentTarget = _this$state2.currentTarget,
          place = _this$state2.place,
          desiredPlace = _this$state2.desiredPlace,
          effect = _this$state2.effect,
          offset = _this$state2.offset;
      var node = this.tooltipRef;
      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      }

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this7.updatePosition();
        });
      } // Set tooltip position


      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }
    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearTimeout(this.delayReshow);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: "hasCustomColors",
    value: function hasCustomColors() {
      var _this8 = this;

      return Boolean(Object.keys(this.state.customColors).find(function (color) {
        return color !== 'border' && _this8.state.customColors[color];
      }) || this.state.border && this.state.customColors['border']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var _this$state3 = this.state,
          extraClass = _this$state3.extraClass,
          html = _this$state3.html,
          ariaProps = _this$state3.ariaProps,
          disable = _this$state3.disable;
      var content = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(content);
      var style = generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
      var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' border' : '') + " place-".concat(this.state.place) + // top, bottom, left, right
      " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + ( // dark, success, warning, error, info, light, custom
      this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
      var Wrapper = this.props.wrapper;

      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(' ');

      if (html) {
        var htmlContent = "".concat(content, "\n<style>").concat(style, "</style>");
        return react_default.a.createElement(Wrapper, _extends({
          className: "".concat(wrapperClassName),
          id: this.props.id,
          ref: function ref(_ref) {
            return _this9.tooltipRef = _ref;
          }
        }, ariaProps, {
          "data-id": "tooltip",
          dangerouslySetInnerHTML: {
            __html: htmlContent
          }
        }));
      } else {
        return react_default.a.createElement(Wrapper, _extends({
          className: "".concat(wrapperClassName),
          id: this.props.id
        }, ariaProps, {
          ref: function ref(_ref2) {
            return _this9.tooltipRef = _ref2;
          },
          "data-id": "tooltip"
        }), react_default.a.createElement("style", {
          dangerouslySetInnerHTML: {
            __html: style
          }
        }), content);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var ariaProps = prevState.ariaProps;
      var newAriaProps = parseAria(nextProps);
      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });

      if (!isChanged) {
        return null;
      }

      return _objectSpread2({}, prevState, {
        ariaProps: newAriaProps
      });
    }
  }]);

  return ReactTooltip;
}(react_default.a.Component), _defineProperty(_class2, "defaultProps", {
  insecure: true,
  resizeHide: true,
  wrapper: 'div',
  clickable: false
}), _defineProperty(_class2, "supportedWrappers", ['div', 'span']), _defineProperty(_class2, "displayName", 'ReactTooltip'), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

/* harmony default export */ var index_es = (index_es_ReactTooltip);
//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ./src/utils/constants/ui.js + 1 modules
var ui = __webpack_require__("IWZK");

// EXTERNAL MODULE: ./src/utils/view.js
var view = __webpack_require__("x9nw");

// CONCATENATED MODULE: ./src/components/Tooltip/index.jsx

var __jsx = react_default.a.createElement;

function Tooltip_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Tooltip_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Tooltip_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var DEFAULT_CLASSES = {
  tooltip: "bg-black-90 white dn-imp-s dib-ns"
};

var Tooltip_Tooltip = function Tooltip(_ref) {
  var tooltip = _ref.tooltip,
      children = _ref.children,
      position = _ref.position,
      id = _ref.id,
      customClasses = _ref.customClasses;

  var classes = _objectSpread(_objectSpread({}, DEFAULT_CLASSES), customClasses);

  if (!id && tooltip) {
    throw new Error("Tooltip needs a unique id");
  }

  var pos = position || ui["o" /* TOOLTIP_POSITION */].TOP;

  if (tooltip) {
    return __jsx(react["Fragment"], null, __jsx("div", {
      className: "flex pointer",
      "data-tip": true,
      "data-for": id
    }, children), !Object(view["b" /* isServer */])() && __jsx(index_es, {
      id: id,
      className: classes.tooltip,
      effect: "solid",
      place: pos
    }, tooltip));
  } else {
    return children;
  }
};

/* harmony default export */ var components_Tooltip = (Tooltip_Tooltip);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 2 modules
var dist_esm_browser_v4 = __webpack_require__("7Cbv");

// CONCATENATED MODULE: ./src/components/HoverIconButton/index.jsx



var HoverIconButton_jsx = react_default.a.createElement;

function HoverIconButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function HoverIconButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HoverIconButton_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HoverIconButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var HoverIconButton_DEFAULT_CLASSES = {
  button: "pa0 ma0 items-center flex pa2 dib items-center justify-center bn br1 panel--action relative",
  "default": "bg-content--secondary",
  active: "bg-content--hover"
};

var HoverIconButton_HoverIconButton = function HoverIconButton(_ref) {
  var _classnames;

  var onClick = _ref.onClick,
      type = _ref.type,
      icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      loading = _ref.loading,
      color = _ref.color,
      disabled = _ref.disabled,
      tooltip = _ref.tooltip,
      tooltipPosition = _ref.tooltipPosition,
      customClasses = _ref.customClasses;

  var classes = HoverIconButton_objectSpread(HoverIconButton_objectSpread({}, HoverIconButton_DEFAULT_CLASSES), customClasses);

  var _useState = Object(react["useState"])(false),
      hover = _useState[0],
      setHover = _useState[1];

  var Icon = Object(utils["a" /* getIconForUID */])(type || icon);

  var NO_OP = function NO_OP() {};

  var tooltipId = Object(react["useMemo"])(function () {
    return Object(dist_esm_browser_v4["a" /* default */])();
  }, []);
  var buttonClasses = classnames_default()(classes.button, (_classnames = {
    "pointer": !disabled,
    "cursor-not-allowed": disabled
  }, Object(defineProperty["a" /* default */])(_classnames, classes["default"], !disabled && !hover), Object(defineProperty["a" /* default */])(_classnames, classes.active, !disabled && hover), Object(defineProperty["a" /* default */])(_classnames, "bg-white o-30", disabled), _classnames));
  var buttonProps = {
    style: {
      outline: "none"
    },
    disabled: disabled,
    onClick: !disabled && onClick || NO_OP,
    onMouseEnter: function onMouseEnter() {
      return !disabled && !hover && setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return !disabled && hover && setHover(false);
    },
    className: buttonClasses
  };
  var iconColor = disabled ? styles["a" /* COLORS */].deselected : color || styles["a" /* COLORS */].icon;
  return HoverIconButton_jsx(components_Tooltip, {
    id: tooltipId,
    tooltip: tooltip,
    position: tooltipPosition
  }, HoverIconButton_jsx("button", Object(esm_extends["a" /* default */])({}, buttonProps, {
    className: style_default.a.dynamic([["1704238731", [styles["c" /* DURATION */] * 2, styles["c" /* DURATION */] * 2, styles["c" /* DURATION */] * 2, styles["c" /* DURATION */] * 2]]]) + " " + (buttonProps && buttonProps.className != null && buttonProps.className || "")
  }), loading ? HoverIconButton_jsx(LoadingSpinner["a" /* default */], {
    customClasses: {
      ring: "blue",
      size: "small"
    }
  }) : HoverIconButton_jsx(react["Fragment"], null, HoverIconButton_jsx(Icon, {
    size: size,
    color: iconColor,
    className: style_default.a.dynamic([["1704238731", [styles["c" /* DURATION */] * 2, styles["c" /* DURATION */] * 2, styles["c" /* DURATION */] * 2, styles["c" /* DURATION */] * 2]]])
  })), HoverIconButton_jsx(style_default.a, {
    id: "1704238731",
    dynamic: [styles["c" /* DURATION */] * 2, styles["c" /* DURATION */] * 2, styles["c" /* DURATION */] * 2, styles["c" /* DURATION */] * 2]
  }, [".panel--action.__jsx-style-dynamic-selector{-webkit-transition:background-color ".concat(styles["c" /* DURATION */] * 2, "s, -webkit-transform ").concat(styles["c" /* DURATION */] * 2, "s;-webkit-transition:background-color ").concat(styles["c" /* DURATION */] * 2, "s, -webkit-transform ").concat(styles["c" /* DURATION */] * 2, "s;-webkit-transition:background-color ").concat(styles["c" /* DURATION */] * 2, "s, transform ").concat(styles["c" /* DURATION */] * 2, "s;transition:background-color ").concat(styles["c" /* DURATION */] * 2, "s, transform ").concat(styles["c" /* DURATION */] * 2, "s;}")])));
};

/* harmony default export */ var components_HoverIconButton = __webpack_exports__["a"] = (HoverIconButton_HoverIconButton);

/***/ }),

/***/ "qFS3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("q1tI");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("i8i4");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("17x9");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__("QEso");

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__("Ye7m");

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__("2zs7");

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__("VCL8");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),

/***/ "sc12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ command_reduceCommands; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ command_getCommandModalClasses; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/remove-accents/index.js
var remove_accents = __webpack_require__("2CXu");
var remove_accents_default = /*#__PURE__*/__webpack_require__.n(remove_accents);

// CONCATENATED MODULE: ./node_modules/match-sorter/dist/match-sorter.esm.js



var rankings = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
matchSorter.rankings = rankings;

var defaultBaseSortFn = function defaultBaseSortFn(a, b) {
  return String(a.rankedValue).localeCompare(String(b.rankedValue));
};
/**
 * Takes an array of items and a value and returns a new array with the items that match the given value
 * @param {Array} items - the items to sort
 * @param {String} value - the value to use for ranking
 * @param {Object} options - Some options to configure the sorter
 * @return {Array} - the new sorted array
 */


function matchSorter(items, value, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      keys = _options.keys,
      _options$threshold = _options.threshold,
      threshold = _options$threshold === void 0 ? rankings.MATCHES : _options$threshold,
      _options$baseSort = _options.baseSort,
      baseSort = _options$baseSort === void 0 ? defaultBaseSortFn : _options$baseSort,
      _options$sorter = _options.sorter,
      sorter = _options$sorter === void 0 ? function (matchedItems) {
    return matchedItems.sort(function (a, b) {
      return sortRankedValues(a, b, baseSort);
    });
  } : _options$sorter;
  var matchedItems = items.reduce(reduceItemsToRanked, []);
  return sorter(matchedItems).map(function (_ref) {
    var item = _ref.item;
    return item;
  });

  function reduceItemsToRanked(matches, item, index) {
    var rankingInfo = getHighestRanking(item, keys, value, options);
    var rank = rankingInfo.rank,
        _rankingInfo$keyThres = rankingInfo.keyThreshold,
        keyThreshold = _rankingInfo$keyThres === void 0 ? threshold : _rankingInfo$keyThres;

    if (rank >= keyThreshold) {
      matches.push(Object(esm_extends["a" /* default */])({}, rankingInfo, {
        item: item,
        index: index
      }));
    }

    return matches;
  }
}
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
 */


function getHighestRanking(item, keys, value, options) {
  if (!keys) {
    // if keys is not specified, then we assume the item given is ready to be matched
    var stringItem = item;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: stringItem,
      rank: getMatchRanking(stringItem, value, options),
      keyIndex: -1,
      keyThreshold: options.threshold
    };
  }

  var valuesToRank = getAllValuesToRank(item, keys);
  return valuesToRank.reduce(function (_ref2, _ref3, i) {
    var rank = _ref2.rank,
        rankedValue = _ref2.rankedValue,
        keyIndex = _ref2.keyIndex,
        keyThreshold = _ref2.keyThreshold;
    var itemValue = _ref3.itemValue,
        attributes = _ref3.attributes;
    var newRank = getMatchRanking(itemValue, value, options);
    var newRankedValue = rankedValue;
    var minRanking = attributes.minRanking,
        maxRanking = attributes.maxRanking,
        threshold = attributes.threshold;

    if (newRank < minRanking && newRank >= rankings.MATCHES) {
      newRank = minRanking;
    } else if (newRank > maxRanking) {
      newRank = maxRanking;
    }

    if (newRank > rank) {
      rank = newRank;
      keyIndex = i;
      keyThreshold = threshold;
      newRankedValue = itemValue;
    }

    return {
      rankedValue: newRankedValue,
      rank: rank,
      keyIndex: keyIndex,
      keyThreshold: keyThreshold
    };
  }, {
    rankedValue: item,
    rank: rankings.NO_MATCH,
    keyIndex: -1,
    keyThreshold: options.threshold
  });
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */


function getMatchRanking(testString, stringToRank, options) {
  testString = prepareValueForComparison(testString, options);
  stringToRank = prepareValueForComparison(stringToRank, options); // too long

  if (stringToRank.length > testString.length) {
    return rankings.NO_MATCH;
  } // case sensitive equals


  if (testString === stringToRank) {
    return rankings.CASE_SENSITIVE_EQUAL;
  } // Lower casing before further comparison


  testString = testString.toLowerCase();
  stringToRank = stringToRank.toLowerCase(); // case insensitive equals

  if (testString === stringToRank) {
    return rankings.EQUAL;
  } // starts with


  if (testString.startsWith(stringToRank)) {
    return rankings.STARTS_WITH;
  } // word starts with


  if (testString.includes(" " + stringToRank)) {
    return rankings.WORD_STARTS_WITH;
  } // contains


  if (testString.includes(stringToRank)) {
    return rankings.CONTAINS;
  } else if (stringToRank.length === 1) {
    // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return rankings.NO_MATCH;
  } // acronym


  if (getAcronym(testString).includes(stringToRank)) {
    return rankings.ACRONYM;
  } // will return a number between rankings.MATCHES and
  // rankings.MATCHES + 1 depending  on how close of a match it is.


  return getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */


function getAcronym(string) {
  var acronym = '';
  var wordsInString = string.split(' ');
  wordsInString.forEach(function (wordInString) {
    var splitByHyphenWords = wordInString.split('-');
    splitByHyphenWords.forEach(function (splitByHyphenWord) {
      acronym += splitByHyphenWord.substr(0, 1);
    });
  });
  return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */


function getClosenessRanking(testString, stringToRank) {
  var matchingInOrderCharCount = 0;
  var charNumber = 0;

  function findMatchingCharacter(matchChar, string, index) {
    for (var j = index, J = string.length; j < J; j++) {
      var stringChar = string[j];

      if (stringChar === matchChar) {
        matchingInOrderCharCount += 1;
        return j + 1;
      }
    }

    return -1;
  }

  function getRanking(spread) {
    var spreadPercentage = 1 / spread;
    var inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
    var ranking = rankings.MATCHES + inOrderPercentage * spreadPercentage;
    return ranking;
  }

  var firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);

  if (firstIndex < 0) {
    return rankings.NO_MATCH;
  }

  charNumber = firstIndex;

  for (var i = 1, I = stringToRank.length; i < I; i++) {
    var matchChar = stringToRank[i];
    charNumber = findMatchingCharacter(matchChar, testString, charNumber);
    var found = charNumber > -1;

    if (!found) {
      return rankings.NO_MATCH;
    }
  }

  var spread = charNumber - firstIndex;
  return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and keyIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */


function sortRankedValues(a, b, baseSort) {
  var aFirst = -1;
  var bFirst = 1;
  var aRank = a.rank,
      aKeyIndex = a.keyIndex;
  var bRank = b.rank,
      bKeyIndex = b.keyIndex;
  var same = aRank === bRank;

  if (same) {
    if (aKeyIndex === bKeyIndex) {
      // use the base sort function as a tie-breaker
      return baseSort(a, b);
    } else {
      return aKeyIndex < bKeyIndex ? aFirst : bFirst;
    }
  } else {
    return aRank > bRank ? aFirst : bFirst;
  }
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */


function prepareValueForComparison(value, _ref4) {
  var keepDiacritics = _ref4.keepDiacritics;
  // value might not actually be a string at this point (we don't get to choose)
  // so part of preparing the value for comparison is ensure that it is a string
  value = "" + value; // toString

  if (!keepDiacritics) {
    value = remove_accents_default()(value);
  }

  return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */


function getItemValues(item, key) {
  if (typeof key === 'object') {
    key = key.key;
  }

  var value;

  if (typeof key === 'function') {
    value = key(item);
  } else if (item == null) {
    value = null;
  } else if (Object.hasOwnProperty.call(item, key)) {
    value = item[key];
  } else if (key.includes('.')) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return getNestedValues(key, item);
  } else {
    value = null;
  } // because `value` can also be undefined


  if (value == null) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [String(value)];
}
/**
 * Given path: "foo.bar.baz"
 * And item: {foo: {bar: {baz: 'buzz'}}}
 *   -> 'buzz'
 * @param path a dot-separated set of keys
 * @param item the item to get the value from
 */


function getNestedValues(path, item) {
  var keys = path.split('.');
  var values = [item];

  for (var i = 0, I = keys.length; i < I; i++) {
    var nestedKey = keys[i];
    var nestedValues = [];

    for (var j = 0, J = values.length; j < J; j++) {
      var nestedItem = values[j];
      if (nestedItem == null) continue;

      if (Object.hasOwnProperty.call(nestedItem, nestedKey)) {
        var nestedValue = nestedItem[nestedKey];

        if (nestedValue != null) {
          nestedValues.push(nestedValue);
        }
      } else if (nestedKey === '*') {
        // ensure that values is an array
        nestedValues = nestedValues.concat(nestedItem);
      }
    }

    values = nestedValues;
  }

  if (Array.isArray(values[0])) {
    // keep allowing the implicit wildcard for an array of strings at the end of
    // the path; don't use `.flat()` because that's not available in node.js v10
    var result = [];
    return result.concat.apply(result, values);
  } // Based on our logic it should be an array of strings by now...
  // assuming the user's path terminated in strings


  return values;
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */


function getAllValuesToRank(item, keys) {
  var allValues = [];

  for (var j = 0, J = keys.length; j < J; j++) {
    var key = keys[j];
    var attributes = getKeyAttributes(key);
    var itemValues = getItemValues(item, key);

    for (var i = 0, I = itemValues.length; i < I; i++) {
      allValues.push({
        itemValue: itemValues[i],
        attributes: attributes
      });
    }
  }

  return allValues;
}

var defaultKeyAttributes = {
  maxRanking: Infinity,
  minRanking: -Infinity
};
/**
 * Gets all the attributes for the given key
 * @param key - the key from which the attributes will be retrieved
 * @return object containing the key's attributes
 */

function getKeyAttributes(key) {
  if (typeof key === 'string') {
    return defaultKeyAttributes;
  }

  return Object(esm_extends["a" /* default */])({}, defaultKeyAttributes, key);
}
/*
eslint
  no-continue: "off",
*/



// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/utils/command.js


/**
 * Reduce commands into matches and sugestions if there are queries
 * @param {Object} params
 * @returns
 */

var command_reduceCommands = function reduceCommands(_ref) {
  var commands = _ref.commands,
      query = _ref.query,
      activeId = _ref.activeId;
  var filtered = [];
  var suggestions = [];
  var matches = [];
  /**
   * Filter commands when query is present
   */

  var hasQuery = query && query.length;

  if (hasQuery) {
    matches = matchSorter(commands, query, {
      keys: ["name", "section", "keywords"]
    });
  } else {
    matches = commands;
  }

  for (var index = 0; index < matches.length; index++) {
    var match = matches[index];

    if (match) {
      var inActiveSection = !activeId && !match.parent || activeId && match.parent === activeId;

      if (inActiveSection) {
        filtered.push(match);
      } else if (hasQuery) {
        suggestions.push(match);
      }
    }
  }

  return {
    filtered: filtered,
    suggestions: suggestions
  };
};
var command_getCommandModalClasses = function getCommandModalClasses() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isVideo = _ref2.isVideo;

  return {
    modal: "modal__content--command br3",
    overlay: "modal__overlay--command",
    container: classnames_default()("bg-white bn br3-ns flex flex-column center", {
      "modal__command--container w-100 w-50-m w-40-l mw6": !isVideo,
      "modal__command--containerVideo w-50": isVideo
    })
  };
};

/***/ }),

/***/ "zGSJ":
/***/ (function(module) {

module.exports = JSON.parse("{\"introduction\":{\"overview\":{\"as\":\"/introduction/overview\",\"href\":\"/introduction/[slug]\"}},\"account\":{\"overview\":{\"as\":\"/account/overview\",\"href\":\"/account/[slug]\"},\"google\":{\"individual\":{\"as\":\"/account/google/individual\",\"href\":\"/account/google/[slug]\"},\"team\":{\"as\":\"/account/google/team\",\"href\":\"/account/google/[slug]\"}}},\"merchant-account\":{\"overview\":{\"as\":\"/merchant-account/overview\",\"href\":\"/merchant-account/[slug]\"},\"stripe\":{\"as\":\"/merchant-account/stripe\",\"href\":\"/merchant-account/[slug]\"},\"onboarding\":{\"overview\":{\"as\":\"/merchant-account/onboarding/overview\",\"href\":\"/merchant-account/onboarding/[slug]\"},\"identity-verification\":{\"as\":\"/merchant-account/onboarding/identity-verification\",\"href\":\"/merchant-account/onboarding/[slug]\"}}},\"resources\":{\"overview\":{\"as\":\"/resources/overview\",\"href\":\"/resources/[slug]\"},\"products\":{\"as\":\"/resources/products\",\"href\":\"/resources/[slug]\"},\"prices\":{\"as\":\"/resources/prices\",\"href\":\"/resources/[slug]\"},\"tax-rates\":{\"as\":\"/resources/tax-rates\",\"href\":\"/resources/[slug]\"},\"coupons\":{\"as\":\"/resources/coupons\",\"href\":\"/resources/[slug]\"}},\"payment-links\":{\"overview\":{\"as\":\"/payment-links/overview\",\"href\":\"/payment-links/[slug]\"},\"payment-details\":{\"as\":\"/payment-links/payment-details\",\"href\":\"/payment-links/[slug]\"},\"payment-methods\":{\"as\":\"/payment-links/payment-methods\",\"href\":\"/payment-links/[slug]\"},\"files\":{\"as\":\"/payment-links/files\",\"href\":\"/payment-links/[slug]\"},\"attribution\":{\"as\":\"/payment-links/attribution\",\"href\":\"/payment-links/[slug]\"},\"shipping-and-addresses\":{\"as\":\"/payment-links/shipping-and-addresses\",\"href\":\"/payment-links/[slug]\"},\"restrictions\":{\"as\":\"/payment-links/restrictions\",\"href\":\"/payment-links/[slug]\"},\"usage\":{\"as\":\"/payment-links/usage\",\"href\":\"/payment-links/[slug]\"},\"metadata\":{\"as\":\"/payment-links/metadata\",\"href\":\"/payment-links/[slug]\"},\"builder\":{\"as\":\"/payment-links/builder\",\"href\":\"/payment-links/[slug]\"}},\"payment-pages\":{\"overview\":{\"as\":\"/payment-pages/overview\",\"href\":\"/payment-pages/[slug]\"},\"form\":{\"overview\":{\"as\":\"/payment-pages/form/overview\",\"href\":\"/payment-pages/form/[slug]\"},\"fields\":{\"overview\":{\"as\":\"/payment-pages/form/fields/overview\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"input\":{\"as\":\"/payment-pages/form/fields/input\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"textarea\":{\"as\":\"/payment-pages/form/fields/textarea\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"select\":{\"as\":\"/payment-pages/form/fields/select\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"multiselect\":{\"as\":\"/payment-pages/form/fields/multiselect\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"toggle\":{\"as\":\"/payment-pages/form/fields/toggle\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"checkbox\":{\"as\":\"/payment-pages/form/fields/checkbox\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"disclaimer\":{\"as\":\"/payment-pages/form/fields/disclaimer\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"datepicker\":{\"as\":\"/payment-pages/form/fields/datepicker\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"phone\":{\"as\":\"/payment-pages/form/fields/phone\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"tax-id\":{\"as\":\"/payment-pages/form/fields/tax-id\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"address\":{\"as\":\"/payment-pages/form/fields/address\",\"href\":\"/payment-pages/form/fields/[slug]\"},\"legal\":{\"as\":\"/payment-pages/form/fields/legal\",\"href\":\"/payment-pages/form/fields/[slug]\"}}}},\"checkout\":{\"overview\":{\"as\":\"/checkout/overview\",\"href\":\"/checkout/[slug]\"},\"redirects\":{\"as\":\"/checkout/redirects\",\"href\":\"/checkout/[slug]\"},\"customize\":{\"as\":\"/checkout/customize\",\"href\":\"/checkout/[slug]\"}},\"content\":{\"overview\":{\"as\":\"/content/overview\",\"href\":\"/content/[slug]\"},\"files\":{\"as\":\"/content/files\",\"href\":\"/content/[slug]\"},\"delivery\":{\"as\":\"/content/delivery\",\"href\":\"/content/[slug]\"},\"security\":{\"as\":\"/content/security\",\"href\":\"/content/[slug]\"}},\"sales\":{\"overview\":{\"as\":\"/sales/overview\",\"href\":\"/sales/[slug]\"},\"receipts-and-invoices\":{\"as\":\"/sales/receipts-and-invoices\",\"href\":\"/sales/[slug]\"},\"dashboards\":{\"as\":\"/sales/dashboards\",\"href\":\"/sales/[slug]\"},\"post-purchase\":{\"as\":\"/sales/post-purchase\",\"href\":\"/sales/[slug]\"},\"emails\":{\"as\":\"/sales/emails\",\"href\":\"/sales/[slug]\"},\"refunds-and-cancellations\":{\"as\":\"/sales/refunds-and-cancellations\",\"href\":\"/sales/[slug]\"}},\"customers\":{\"overview\":{\"as\":\"/customers/overview\",\"href\":\"/customers/[slug]\"},\"billing\":{\"as\":\"/customers/billing\",\"href\":\"/customers/[slug]\"},\"one-click-unsubscribe\":{\"as\":\"/customers/one-click-unsubscribe\",\"href\":\"/customers/[slug]\"}},\"billing\":{\"overview\":{\"as\":\"/billing/overview\",\"href\":\"/billing/[slug]\"}},\"automation\":{\"overview\":{\"as\":\"/automation/overview\",\"href\":\"/automation/[slug]\"},\"zapier\":{\"overview\":{\"as\":\"/automation/zapier/overview\",\"href\":\"/automation/zapier/[slug]\"},\"app\":{\"as\":\"/automation/zapier/app\",\"href\":\"/automation/zapier/[slug]\"},\"setup\":{\"as\":\"/automation/zapier/setup\",\"href\":\"/automation/zapier/[slug]\"},\"format\":{\"as\":\"/automation/zapier/format\",\"href\":\"/automation/zapier/[slug]\"},\"filter\":{\"as\":\"/automation/zapier/filter\",\"href\":\"/automation/zapier/[slug]\"},\"example\":{\"as\":\"/automation/zapier/example\",\"href\":\"/automation/zapier/[slug]\"}}}}");

/***/ })

}]);